/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export default {
  translation: {
    "appName": "Constantina",
    "nav_home": "Home",
    "nav_about": "About",
    "nav_portfolio": "Portfolio",
    "nav_blog": "Blog",
    "nav_services": "Services",
    "nav_bookSession": "Book Session",
    "nav_dressingRoom": "Dressing Room",
    "nav_myStyles": "My Styles",
    "nav_advisor": "Style Advisor",
    "nav_trends": "Trends",
    "nav_fashion": "Fashion",
    "nav_travel": "Travel",
    "nav_color_studio": "Color Studio",
    "nav_capsule_generator": "Capsule Generator",
    "nav_outfits": "Outfits",
    "nav_lookbooks": "Lookbooks",
    "header_title": "Constantina",
    "nav_shopping_assistant": "Shopping Assistant",
    "nav_assistant_short": "Assistant",
    "nav_style_lab": "Style Lab",
    "nav_studio": "Style Studio",
    "nav_tryon": "Virtual Try-On",
    "nav_actions_title": "Actions",
    "shoppingAssistant_membership_locked": "Locked for Premium members",


    // Wizard
    "wizard_title": "How would you like to proceed?",
    "wizard_subtitle": "Choose the path that fits your style goals perfectly.",
    "wizard_membership_title": "Become a Member",
    "wizard_membership_desc": "Unlock the full power of AI styling, virtual try-ons, and personal style agents.",
    "wizard_membership_feature_1": "Unlimited AI Outfit Generations",
    "wizard_membership_feature_2": "Access to Advanced Style Agents",
    "wizard_membership_feature_3": "Virtual Try-On on Your Own Photo",
    "wizard_membership_cta": "View Membership Plans",
    "wizard_consultation_title": "Book a Consultation",
    "wizard_consultation_desc": "Get personalized, one-on-one professional advice from human experts.",
    "wizard_consultation_feature_1": "1-on-1 Style Consultation",
    "wizard_consultation_feature_2": "Professional Photo Shoots",
    "wizard_consultation_feature_3": "Personal Shopping Experience",
    "wizard_consultation_cta": "Book a Session",
    "wizard_skip": "I'll explore on my own first",

    // Style Swipe
    "styleSwipe_section_label": "Personalize Your AI",
    "styleSwipe_section_title": "Fine-tune your style profile",
    "styleSwipe_section_desc": "Swipe right on looks you love to help your AI stylist understand your unique taste better. The more you swipe, the better your recommendations.",
    "styleSwipe_finished_title": "Style Profile Updated!",
    "styleSwipe_finished_desc": "Your recommendations are now tuned to your unique taste.",

    // Digital Box
    "digitalBox_title": "Curate My Digital Box",
    "digitalBox_subtitle": "Tell us what you need, and our AI will handpick 5 cohesive items for you, presented in a personalized video lookbook.",
    "digitalBox_label_occasion": "What's the occasion?",
    "digitalBox_label_vibe": "What's the vibe?",
    "digitalBox_cta_generate": "Generate My Box",
    "digitalBox_processing_title": "Curating your look...",
    "digitalBox_processing_desc": "Our AI is analyzing thousands of items to match your vibe.",

    // Discrete Reports
    "unlock_report_button": "Unlock Color Report ($19)",
    "unlock_report_desc": "Get your full season analysis and palette without a monthly subscription.",

    // SEO & Content - Color Studio
    "colorStudio_seo_title": "Personal & Seasonal Color Analysis | Find Your Palette",
    "colorStudio_seo_desc": "Detailed analysis of your personal color season and palette. Identify warm vs cool undertones.",
    "colorStudio_seo_keywords": "seasonal color analysis, personal color analysis, find my color season, spring color palette, summer color palette, autumn color palette, winter color palette, warm undertones, cool undertones",
    "colorStudio_title": "Color Analysis Studio",
    "colorStudio_subtitle": "Unlock the power of color. Discover the shades that harmonize with your unique skin tone, hair, and eyes.",
    "colorStudio_powerColors_desc": "The key colors that enhance your natural beauty.",
    "colorStudio_premium_required": "Unlock personalized seasonal color analysis and palette recommendations. Available for Premium and Advanced members.",

    "colorAnalysis_title": "Color Analysis",
    "colorAnalysis_confirm_new": "You already have a color analysis in your profile. Would you like to perform a new image-based detection?",
    "colorAnalysis_analyze_new": "Analyze New Photo",
    "colorAnalysis_analyzing": "Analyzing your colors...",
    "colorAnalysis_analyzing_subtext": "Determining season, skin tone, and contrast.",
    "colorAnalysis_upload_title": "Upload Photo",
    "colorAnalysis_upload_btn": "Select Image",
    "colorAnalysis_season_label": "Your Season",
    "colorAnalysis_characteristic_skin": "Skin:",
    "colorAnalysis_characteristic_contrast": "Contrast:",
    "colorAnalysis_characteristic_eyes": "Eyes:",
    "colorAnalysis_characteristic_hair": "Hair:",
    "colorAnalysis_powerColors": "Power Colors",
    "colorAnalysis_neutrals": "Neutrals",
    "colorAnalysis_avoid": "Colors to Avoid",
    "colorAnalysis_advice_hair_makeup": "Hair & Makeup",
    "colorAnalysis_advice_clothing": "Clothing Advice",
    "colorAnalysis_error": "Analysis failed.",
    "colorAnalysis_no_result_title": "No Color Analysis Yet",
    "colorAnalysis_no_result_desc": "Upload a photo or select a saved outfit to discover your personal color season and palette.",
    "colorAnalysis_start_button": "Start my Color Analysis",
    "colorAnalysis_label_hair": "Hair",
    "colorAnalysis_label_makeup": "Makeup",
    "colorAnalysis_label_jewelry": "Jewelry",
    "colorAnalysis_saved_to_profile": "Saved to Profile",
    "colorAnalysis_save_to_profile": "Save Analysis to Profile",
    "colorAnalysis_apply_palette_title": "Apply Palette to Outfit",
    "colorAnalysis_apply_palette_hint": "Click a color to apply it",
    "colorAnalysis_apply_color_aria": "Apply color {{color}}",
    "colorAnalysis_target_item": "Target Item",
    "colorAnalysis_powerColors_desc": "These essential colors project your maximum confidence and vibrancy.",
    "colorAnalysis_admin_mode": "ADMIN",
    "colorAnalysis_admin_analyzing": "Analyzing curated set...",
    "colorAnalysis_admin_label": "Admin Mode:",
    "colorAnalysis_admin_desc": "Upload a detailed outfit photo to extract items and create a Shop the Look set.",
    "colorAnalysis_admin_save_set": "Save to Curated Sets",
    "colorAnalysis_admin_shop_now": "Shop Now Link",
    "colorAnalysis_admin_failed_analyze": "Failed to analyze set",
    "colorAnalysis_admin_failed_save": "Failed to save.",
    "colorAnalysis_admin_curated_saved": "Curated Set & Items Saved! (Refresh to see in Wardrobe)",
    "colorAnalysis_characteristic_skinTone": "Skin Tone",
    "colorAnalysis_characteristic_hairColor": "Hair Color",
    "colorAnalysis_characteristic_eyeColor": "Eye Color",
    "colorAnalysis_characteristic_faceShape": "Face Shape",
    "colorAnalysis_characteristic_bodySize": "Body Size",
    "colorAnalysis_save_to_advice_title": "Color Analysis - {{season}}",
    "colorAnalysis_unknown": "Unknown",
    "colorAnalysis_saved_to_profile_success": "Saved to profile",
    "myStylesPage_savedColorAnalysis_title": "My Color Palette Analyses",
    "myStylesPage_savedColorAnalysis_desc": "Your history of personal color discoveries and seasonality.",
    "myStylesPage_noSavedAnalysis": "No saved color analysis results yet.",


    // SEO & Content - Travel
    "travelPage_seo_title": "Luxury Fashion Travel Packing List & Resort Wear",
    "travelPage_seo_desc": "Curate the ultimate luxury travel packing list. From resort wear to city break essentials, plan your stylish getaway with AI-powered outfit recommendations.",
    "travelPage_seo_keywords": "luxury travel packing list, fashion travel packing list, resort wear, chic travel wardrobe, vacation outfits, high-end travel essentials, designer packing list",
    "travelPage_diaries_title": "Travel Diaries",
    "travelPage_no_lookbooks": "No travel lookbooks found.",
    "travelPage_destination_label": "Where to?",
    "travelPage_destination_placeholder": "e.g. Paris, Tulum, Aspen",
    "travelPage_style_summer": "Summer / Beach",
    "travelPage_style_winter": "Winter / Ski",
    "travelPage_generating": "Curating Wardrobe...",
    "travelPage_generate_btn": "Generate Packing List",
    "travelPage_result_title": "Your {{destination}} Capsule",
    "travelPage_save_diary": "Save to Diary",
    "travelPage_export_pdf": "Export PDF",

    // Mock Travel Items
    "travelPage_item_blazer": "Linen Blazer - Beige",
    "travelPage_item_camisole": "Silk Camisole - White",
    "travelPage_item_trousers": "Wide-Leg Trousers - Navy",
    "travelPage_item_sandals": "Leather Sandals - Tan",
    "travelPage_item_earrings": "Statement Earrings - Gold",
    "travelPage_item_hat": "Sun Hat - Woven",
    "travelPage_item_clutch": "Evening Clutch - Black",
    "travelPage_item_swimsuit": "Swimsuit - One Piece",

    "trend_tag_heritage": "Heritage",
    "trend_tag_sculpted": "Sculpted",
    "trend_tag_heritage_fusion": "Heritage Fusion",
    "trend_tag_ai_vision": "AI Vision",
    "trend_tag_emerging": "Emerging",
    "trend_tag_alpine_chic": "Alpine Chic",
    "trend_tag_cyber_soft": "Cyber Soft",
    "trend_tag_poet_core": "Poet Core",
    "trend_tag_glamoratti": "Glamoratti",
    "trend_tag_guardian": "Guardian",
    "nav_privacy": "Privacy",
    "nav_terms": "Terms",
    "nav_impressum": "Impressum",
    "nav_startOver": "Start Over",
    "nav_save": "Save",
    "nav_share": "Share",
    "nav_findSimilar": "Find Similar",
    "nav_getStyleTip": "Get Tips",
    "nav_lookbook": "Lookbook",
    "nav_lightMode": "Light Mode",
    "nav_darkMode": "Dark Mode",
    "nav_switchUser": "Switch User",
    "nav_profile": "Profile",
    "nav_wardrobe": "Wardrobe",
    "nav_outfit": "Outfit",
    "nav_guestCta": "Sign in to access",
    "nav_show_wardrobe": "Show Wardrobe",
    "nav_hide_wardrobe": "Hide Wardrobe",
    "nav_show_outfit": "Show Outfit",
    "nav_hide_outfit": "Hide Outfit",
    "nav_signInGoogle": "Sign in with Google",
    "nav_signInDrive": "Sign in with Google Drive",
    "nav_signInPhotos": "Sign in with Google Photos",
    "nav_signInFacebook": "Sign in with Facebook",
    "nav_rememberMe": "Remember Me",
    "nav_signUp": "Sign Up",
    "nav_emailPlaceholder": "Email",
    "nav_passwordPlaceholder": "Password",
    "nav_signUpButton": "Create Account",
    "nav_continueWith": "Or continue with",
    "nav_guestUser": "(Guest)",
    "nav_proceedToStyling": "Proceed to Styling",
    "nav_help": "Help Center",
    "nav_logout": "Log Out",
    "loading_updating_item": "Updating item...",
    "loading_updating_pose": "Transposing to {{poseName}}...",
    "loading_updating_background": "Updating background...",
    "loading_ageing_correction": "Analyzing facial features for rejuvenation...",
    "loading_wrinkle_removal": "Smoothening skin texture...",
    "loading_golden_hour": "Applying cinematic lighting...",
    "loading_remove_glasses": "Removing glasses and reconstructing eye area...",
    "loading_remove_hat": "Removing headwear and reconstructing hair...",
    "loading_remove_watch": "Removing wrist accessory...",
    "loading_remove_bag": "Removing bag and reconstructing background...",
    "loading_updating_3d": "Generating 3D view ({{current}}/4)...",
    "error_3d_partial_success": "3D generation partially successful ({{success}}/{{total}} steps).",
    "error_3d_total_failure": "3D generation failed for all steps. Please try again.",
    "loading_updating_generic": "Updating...",
    "analyze_confidence_title": "Analyze Fit Confidence",
    "generate_runway_video": "Generate Runway Video",
    "fit_status_tight": "Tight",
    "fit_status_loose": "Loose",
    "fit_status_perfect": "Perfect",
    "style_report_title": "Comprehensive Style Report",
    "report_total_score": "Overall Style Score",
    "report_color_harmony": "Color Harmony",
    "report_agent_reviews": "Advisor Reviews",
    "report_fit_summary": "Reality Fit Check",
    "report_user_feedback": "Your Review",
    "error_update_outfit": "Failed to update outfit. {{details}}",
    "error_creative_edit": "Failed to apply creative edit ({{details}}).",
    "creative_tools_title": "Creative AI Tools",
    "creative_tool_ageing_label": "Face Ageing Correction",
    "creative_tool_ageing_desc": "Subtle rejuvenation of facial features.",
    "creative_tool_wrinkles_label": "Wrinkle Removal",
    "creative_tool_wrinkles_desc": "Naturally smoothen skin and remove fine lines.",
    "creative_tool_golden_hour_label": "Golden Hour Filter",
    "creative_tool_golden_hour_desc": "Warm, cinematic lighting for a luxury look.",
    "creative_tool_remove_glasses_label": "Remove Glasses",
    "creative_tool_remove_glasses_desc": "AI-empowered removal of eyewear with eye reconstruction.",
    "creative_tool_remove_hat_label": "Remove Hat",
    "creative_tool_remove_hat_desc": "Remove headwear and naturally reconstruct hair.",
    "creative_tool_remove_watch_label": "Remove Watch",
    "creative_tool_remove_watch_desc": "Remove watches or wrist accessories.",
    "creative_tool_remove_bag_label": "Remove Bag",
    "creative_tool_remove_bag_desc": "Remove handheld bags and reconstruct background.",
    "creative_tools_disclaimer": "Results are AI-generated and may vary based on photo quality.",

    "error_save_outfit": "Failed to save outfit. {{details}}",
    "common_user": "User",
    "canvas_colorPicker_title": "Color Picker",
    "wardrobe_item_tooltip_locked": "Locked: Requires {{level}} Membership.",
    "wardrobe_item_tooltip_category": "Category: {{category}}",
    "wardrobe_item_tooltip_color": "Default Color: {{color}}",
    "wardrobe_brand_ai_generated": "AI Generated",
    "wardrobe_item_ai_name_prefix": "AI: {{prompt}}",

    "authModal_title": "Sign In to Constantina",
    "authModal_subtitle": "Unlock your personal AI stylist.",
    "authModal_verifying": "Verifying Credentials...",
    "authModal_connecting_provider": "Connecting to {{provider}}",
    "authModal_success": "Successfully Authenticated",
    "authModal_redirecting": "Redirecting you now...",
    "auth_error_invalid_credentials": "Invalid email or password.",
    "voucher_modal_title": "Purchase Gift Voucher",
    "premium_feature_modal_title": "Premium Feature",
    "premium_feature_modal_desc": "This exclusive feature is available for {{level}} members. Upgrade your plan to unlock full access to our AI-powered style tools and premium wardrobe.",
    "premium_feature_modal_cta": "View Membership Plans",
    "voucher_modal_success_title": "Voucher Created!",
    "voucher_modal_success_message": "Your voucher has been successfully created. You can copy the code below.",
    "voucher_modal_service_label": "Select Services to Include",
    "voucher_modal_recipient_name_label": "Recipient Name",
    "voucher_modal_recipient_name_placeholder": "e.g. Jane Doe",
    "voucher_modal_recipient_email_label": "Recipient Email",
    "voucher_modal_recipient_email_placeholder": "jane@example.com",
    "voucher_modal_message_label": "Personal Message",
    "voucher_modal_message_placeholder": "Write a note...",
    "voucher_modal_purchase_button": "Purchase Voucher",
    "voucher_modal_purchasing": "Processing...",
    "voucher_modal_copy_code": "Copy Code",

    "stylingAdvisorPage_greeting": "Hello! I'm your personal AI stylist. How can I help you elevate your look today?",
    "stylingAdvisorPage_tagline": "Your personal AI fashion consultant.",
    "stylingAdvisorPage_chatSection": "Chat",
    "stylingAdvisorPage_agentSelectorLabel": "Choose an Agent",
    "stylingAdvisorPage_planSectionTitle": "Style Plan",
    "stylingAdvisorPage_planSectionDescription": "Generate a personalized style roadmap based on your preferences.",
    "stylingAdvisorPage_photoAnalysisSectionTitle": "Color Analysis",
    "stylingAdvisorPage_photoAnalysisSectionDescription": "Upload a photo to discover your seasonal color palette.",
    "stylingAdvisorPage_photoAnalysisButton": "Analyze My Photo",
    "stylingAdvisorPage_photoAnalysisSelectLabel": "Select from Saved Outfits",
    "stylingAdvisorPage_agentsSectionTitle": "Automated Agents",
    "stylingAdvisorPage_agentsDashboardTitle": "My Active Style Agents",
    "stylingAdvisorPage_createAgent": "Create New Agent",
    "stylingAdvisorPage_noAgents": "You haven't created any automated agents yet.",
    "stylingAdvisorPage_historySection": "My Searches",
    "stylingAdvisorPage_noSearches": "You haven't saved any searches yet.",
    "stylingAdvisorPage_thinking": "Thinking...",
    "stylingAdvisorPage_generatePlan": "Generate Plan",
    "stylingAdvisorPage_regeneratePlan": "Regenerate",
    "stylingAdvisorPage_saveSuccess": "Saved!",
    "stylingAdvisorPage_planSavedTitle": "{{duration}} Style Plan",
    "stylingAdvisorPage_placeholder": "Ask for advice...",
    "stylingAdvisorPage_planDuration_weekly": "Weekly",
    "stylingAdvisorPage_planDuration_monthly": "Monthly",
    "stylingAdvisorPage_planDuration_quarterly": "Quarterly",
    "stylingAdvisorPage_mandatory_fields_tooltip": "Complete your Style Persona in Profile to unlock.",

    "stylingAdvisorPage_agent_fashionExpert_name": "Fashion Expert",
    "stylingAdvisorPage_agent_fashionExpert_description": "General style advice and trend spotting.",
    "stylingAdvisorPage_agent_minimalistStylist_name": "Minimalist Stylist",
    "stylingAdvisorPage_startChat": "Start Chat",
    "stylingAdvisorPage_title": "Personal Styling Advisor",
    "stylingAdvisorPage_agent_minimalistStylist_description": "Clean lines, neutral palettes, and capsule wardrobes.",
    "stylingAdvisorPage_agent_styleQuestionnaire_name": "Style Questionnaire",
    "stylingAdvisorPage_agent_styleQuestionnaire_description": "Discover your unique style persona through Q&A.",
    "stylingAdvisorPage_agent_business_name": "Business Professional",
    "stylingAdvisorPage_agent_business_description": "Corporate and smart-casual workwear advice.",
    "stylingAdvisorPage_agent_vogueEditor_name": "Editorial Chic",
    "stylingAdvisorPage_agent_vogueEditor_description": "High-fashion, bold, and trend-setting looks.",
    "stylingAdvisorPage_agent_glamour_name": "Red Carpet Glamour",
    "stylingAdvisorPage_agent_glamour_description": "Evening wear and special occasion styling.",

    "stylingAdvisorPage_agent_locked_basic": "Basic Plan Required",
    "stylingAdvisorPage_agent_locked_premium": "Premium Plan Required",
    "stylingAdvisorPage_agent_locked_advanced": "Advanced Plan Required",
    "stylingAdvisorPage_questionnaire": "Style Questionnaire",
    "stylingAdvisorPage_questionnaire_wizard_title": "Style Discovery Wizard",
    "stylingAdvisorPage_questionnaire_wizard_step_evolution": "What phase of inner development are you currently reflecting?",
    "stylingAdvisorPage_questionnaire_wizard_phase_emergence": "Emergence (New Beginnings)",
    "stylingAdvisorPage_questionnaire_wizard_phase_leadership": "Leadership (Stepping into Power)",
    "stylingAdvisorPage_questionnaire_wizard_phase_reclamation": "Reclamation (Owning Your Truth)",
    "stylingAdvisorPage_questionnaire_wizard_phase_transition": "Transition (Embracing Change)",
    "stylingAdvisorPage_questionnaire_wizard_phase_mastery": "Mastery (Peak Expression)",
    "stylingAdvisorPage_questionnaire_wizard_step_archetype": "What is your current style Archetype?",
    "stylingAdvisorPage_questionnaire_wizard_arch_muse": "The Muse (Inspirational & Fluid)",
    "stylingAdvisorPage_questionnaire_wizard_arch_warrior": "The Warrior (Strong & Direct)",
    "stylingAdvisorPage_questionnaire_wizard_arch_creator": "The Creator (Artistic & Original)",
    "stylingAdvisorPage_questionnaire_wizard_arch_healer": "The Healer (Soft & Nurturing)",
    "stylingAdvisorPage_questionnaire_wizard_arch_ruler": "The Ruler (Commanding & Noble)",
    "stylingAdvisorPage_questionnaire_wizard_arch_magician": "The Magician (Transformative & Charismatic)",
    "stylingAdvisorPage_questionnaire_wizard_step_generation": "Generation",
    "stylingAdvisorPage_questionnaire_wizard_step_lifestyle": "Lifestyle",
    "stylingAdvisorPage_questionnaire_wizard_step_body": "Body & Face",
    "stylingAdvisorPage_questionnaire_wizard_step_persona": "Style Persona",
    "stylingAdvisorPage_questionnaire_wizard_gen_alpha": "Generation Alpha",
    "stylingAdvisorPage_questionnaire_wizard_gen_z": "Generation Z",
    "stylingAdvisorPage_questionnaire_wizard_gen_millennial": "Millennial",
    "stylingAdvisorPage_questionnaire_wizard_gen_x": "Generation X",
    "stylingAdvisorPage_questionnaire_wizard_gen_boomer": "Baby Boomer",
    "stylingAdvisorPage_questionnaire_wizard_gen_classic": "Classic / Silent Generation",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_office": "How much time do you spend in the office?",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_outside": "How much time do you spend outside / outdoors?",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_outdoor": "How much time do you spend outside / outdoors?",
    "stylingAdvisorPage_questionnaire_wizard_lifestyle_travel": "How much time do you spend traveling?",
    "stylingAdvisorPage_questionnaire_wizard_intensity_none": "None",
    "stylingAdvisorPage_questionnaire_wizard_intensity_low": "Low",
    "stylingAdvisorPage_questionnaire_wizard_intensity_medium": "Medium",
    "stylingAdvisorPage_questionnaire_wizard_intensity_high": "High",
    "stylingAdvisorPage_questionnaire_wizard_finish": "Complete Discovery",
    "stylingAdvisorPage_questionnaire_wizard_success": "Profile updated! Your AI stylist is now perfectly tuned to your life.",
    "stylingAdvisorPage_questionnaire_wizard_persona_minimalist": "Minimalist",
    "stylingAdvisorPage_questionnaire_wizard_persona_bohoChic": "Boho Chic",
    "stylingAdvisorPage_questionnaire_wizard_persona_classicProfessional": "Classic Professional",
    "stylingAdvisorPage_questionnaire_wizard_persona_streetwear": "Streetwear",
    "stylingAdvisorPage_questionnaire_wizard_persona_avantGarde": "Avant-Garde",
    "stylingAdvisorPage_questionnaire_wizard_persona_vintageRetro": "Vintage Retro",
    "stylingAdvisorPage_questionnaire_wizard_persona_activewear": "Activewear",
    "stylingAdvisorPage_questionnaire_wizard_persona_glamorous": "Glamorous",

    "stylingAdvisorPage_planError": "Could not generate style plan. Please try again.",

    "styleBot_questionnaire_intro": "Hi! To give you the best advice, I'd love to know: 1. Gender 2. Body Shape 3. Face Shape 4. Color Season 5. Style Preference. You can answer all at once or one by one!",
    "styleBot_chip_female": "Female",
    "styleBot_chip_male": "Male",
    "styleBot_chip_non_binary": "Non-Binary",
    "styleBot_chip_hourglass": "Hourglass Body",
    "styleBot_chip_pear": "Pear Shape",
    "styleBot_chip_rectangle": "Rectangle Shape",
    "styleBot_chip_athletic": "Athletic Build",
    "styleBot_chip_oval_face": "Oval Face",
    "styleBot_chip_square_face": "Square Face",
    "styleBot_chip_round_face": "Round Face",
    "styleBot_chip_heart_face": "Heart Face",
    "styleBot_chip_winter": "Winter Season",
    "styleBot_chip_summer": "Summer Season",
    "styleBot_chip_autumn": "Autumn Season",
    "styleBot_chip_spring": "Spring Season",
    "styleBot_chip_minimalist": "Minimalist Style",
    "styleBot_chip_boho": "Boho Chic",
    "styleBot_chip_classic": "Classic Style",
    "styleBot_chip_streetwear": "Streetwear",

    "styleAgent_modal_title": "Automated Style Agent",
    "styleAgent_modal_desc": "Create an AI agent that periodically scouts for new trends and items tailored for you.",
    "styleAgent_name_label": "Agent Name",
    "styleAgent_name_placeholder": "e.g. Summer Trend Scout",
    "styleAgent_frequency_label": "Frequency",
    "styleAgent_season_label": "Target Season",
    "styleAgent_focus_label": "Focus Area",
    "styleAgent_useStyles_label": "Use my Saved Styles for context",
    "styleAgent_profileRetailers_label": "Retailers (from profile)",
    "styleAgent_create_btn": "Create Agent",
    "styleAgent_freq_weekly": "Weekly",
    "styleAgent_freq_monthly": "Monthly",

    "helpPage_title": "Help Center",
    "helpPage_subtitle": "Find answers to your questions and learn how to use Constantina.",
    "helpPage_searchPlaceholder": "Search for help...",
    "helpPage_noResults": "No help articles found matching your search.",
    "helpPage_chatbot_title": "Need more help?",
    "helpPage_chatbot_desc": "Our AI Styling Advisor can answer your questions about the app.",
    "helpPage_chatbot_button": "Ask Advisor",
    "help_category_getting-started": "Getting Started",
    "help_category_virtual-try-on": "Virtual Try-On",
    "help_category_wardrobe": "Wardrobe & Items",
    "help_category_account": "Account & Plans",
    "help_category_technical": "Technical Support",

    "help_q_how_to_start": "How do I start using the Virtual Try-On?",
    "help_a_how_to_start": "First, upload a clear photo of yourself on the Home page. Our AI will generate a model. Then, you'll be taken to the Dressing Room where you can select clothes from the Wardrobe panel.",
    "help_q_accuracy": "How accurate is the virtual try-on?",
    "help_a_accuracy": "Constantina uses advanced generative AI to visualize outfits. While highly realistic, it is a simulation for style inspiration and may not perfectly reflect physical fit or exact fabric drape.",
    "help_q_change_pose": "Can I change the model's pose?",
    "help_a_change_pose": "Yes! In the Dressing Room, use the pose bar at the bottom of the screen to select from various poses like 'Walking', 'Sitting', or 'Athletic'.",
    "help_q_upload_clothes": "Can I upload my own clothes?",
    "help_a_upload_clothes": "Absolutely. In the Wardrobe panel (left side), click the 'Upload' box under the relevant category (e.g., Tops) to add your own items.",
    "help_q_delete_item": "How do I remove an item from my outfit?",
    "help_a_delete_item": "In the Outfit Stack (right panel), find the item you want to remove and click the trash can icon next to it.",
    "help_q_reset_password": "How do I reset my password?",
    "help_a_reset_password": "Currently, this is a demo environment. You can create a new user account at any time from the login menu.",
    "help_q_subscription": "What do the different membership plans offer?",
    "help_a_subscription": "Basic allows standard access. Premium unlocks unlimited wardrobe items and priority support. Advanced gives you access to the highest quality image generation and exclusive AI tools like the Style Bot.",
    "help_q_slow_generation": "Why is the image generation slow?",
    "help_a_slow_generation": "Generative AI requires significant processing power. High-quality images can take 10-20 seconds to generate depending on server load.",

    "onboarding_step1_title": "Select Items",
    "onboarding_step1_content": "This is your Wardrobe. Click on any garment to try it on your model.",
    "onboarding_step2_title": "Virtual Canvas",
    "onboarding_step2_content": "Your model appears here. You can change the background scene using the controls at the top left.",
    "onboarding_step3_title": "Manage Layers",
    "onboarding_step3_content": "Track what you're wearing here. You can remove items or change their colors.",
    "onboarding_step4_title": "Change Pose",
    "onboarding_step4_content": "Use the bar below to see your outfit in different poses and angles.",
    "onboarding_skip": "Skip Tour",

    "blogPage_resources_locked_title": "Unlock Premium Content",
    "portfolioPage_title": "Premium AI Stylist & Personal Branding",
    "portfolioPage_tagline": "Elevate your professional image with our tailored styling packages and executive branding solutions.",
    "portfolioPage_seo_title": "Premium Services | Constantina",
    "portfolioPage_seo_desc": "Discover our bespoke styling packages and executive branding solutions. Professional image consulting and personal shopping.",
    "portfolioPage_seo_keywords": "premium styling, fashion concierge, executive branding, personal shopping",
    "seo_services_title": "Premium Fashion Styling & Executive Branding | Constantina",
    "seo_services_description": "Book professional personal styling consultations, wardrobe curation, and executive branding sessions. Transformation through AI-powered fashion technology.",
    "seo_services_kw1": "personal styling",
    "seo_services_kw2": "wardrobe curation",
    "seo_services_kw3": "image consulting",
    "seo_services_kw4": "virtual try-on fashion",
    "portfolioPage_campaigns_title": "Current Campaigns",
    "portfolioPage_campaigns_tagline": "Exclusive offers for a limited time.",
    "portfolioPage_membership_title": "Membership Plans",
    "portfolioPage_membership_tagline": "Unlock exclusive features and content.",

    "portfolioPage_services_title": "Our Services",
    "portfolioPage_all_categories": "All Categories",
    "portfolioPage_bookService": "Book Service",
    "portfolioPage_package_online": "Online",
    "portfolioPage_package_aiEnhanced": "AI Enhanced",
    "portfolioPage_package_inPerson": "In Person",
    "portfolioPage_package_teamWorkshop": "Team Workshop",
    "portfolioPage_package_executiveBranding": "Executive Branding",
    "portfolioPage_package_corporateEvent": "Corporate Event",

    "price_basic_weekly": "$9.99/week",
    "price_basic_monthly": "$29.99/month",
    "price_basic_quarterly": "$79.99/quarter",
    "price_premium_weekly": "$19.99/week",
    "price_premium_monthly": "$59.99/month",
    "price_premium_quarterly": "$159.99/quarter",
    "price_advanced_weekly": "$39.99/week",
    "price_advanced_monthly": "$119.99/month",
    "price_advanced_quarterly": "$319.99/quarter",
    "price_nextgen_weekly": "$4.99/week",
    "price_nextgen_monthly": "$14.99/month",

    "price_personal_styling_online": "$150",
    "price_personal_styling_ai": "$250",
    "price_personal_styling_in_person": "$500",
    "price_wardrobe_curation_online": "$200",
    "price_wardrobe_curation_ai": "$300",
    "price_wardrobe_curation_in_person": "$600",
    "price_event_styling_online": "$100",
    "price_event_styling_ai": "$180",
    "price_event_styling_in_person": "$400",
    "price_individual_shopping_online": "$120",
    "price_individual_shopping_ai": "$220",
    "price_individual_shopping_in_person": "$450",
    "price_makeup_advisory_online": "$80",
    "price_makeup_advisory_ai": "$150",
    "price_makeup_advisory_in_person": "$300",
    "price_color_analysis_online": "$90",
    "price_color_analysis_ai": "$160",
    "price_color_analysis_in_person": "$350",
    "price_business_workshop_team": "$1,200",
    "price_business_workshop_executive": "$2,500",
    "price_business_workshop_corporate": "$5,000+",
    "price_style_transformation_essential": "$450",
    "price_style_transformation_complete": "$850",
    "price_style_transformation_vip": "$1,500",

    "portfolio_feature_1hr_video_call": "1-on-1 Style Video Call",
    "portfolio_feature_style_questionnaire": "Comprehensive Style Questionnaire",
    "portfolio_feature_personalized_mood_board": "Personalized Style Mood Board",
    "portfolio_feature_all_online_features": "Includes all Online Features",
    "portfolio_feature_virtual_try_on_session": "AI Virtual Try-On Session",
    "portfolio_feature_ai_lookbook": "Custom AI Lookbook",
    "portfolio_feature_retail_search": "Global Retail Item Search",
    "portfolio_feature_all_ai_features": "Includes all AI-Enhanced Features",
    "portfolio_feature_in_person_consultation": "In-Person Style Consultation",
    "portfolio_feature_hands_on_styling": "Hands-On Wardrobe Styling",
    "portfolio_feature_wardrobe_analysis": "Professional Wardrobe Analysis",
    "portfolio_feature_declutter_guide": "Sustainable Decluttering Guide",
    "portfolio_feature_shopping_list": "Curated Shopping Essentials List",
    "portfolio_feature_ai_outfit_pairing": "AI-Powered Outfit Pairing",
    "portfolio_feature_seasonal_capsule": "Personal Seasonal Capsule Plan",
    "portfolio_feature_team_style_guide": "Custom Team Style & Branding Guide",
    "portfolio_feature_brand_identity_alignment": "Brand Identity Alignment Session",
    "portfolio_feature_group_qa": "Interactive Group Q&A Session",
    "portfolio_feature_executive_presence": "Executive Presence & Power Dressing",
    "portfolio_feature_personal_shopping_day": "Full Day Personal Shopping Experience",
    "portfolio_feature_keynote_speech": "Style & Identity Keynote Speech",
    "portfolio_feature_pop_up_styling": "Corporate Pop-Up Styling Station",
    "portfolio_feature_digital_palette": "Interactive Digital Color Palette",
    "portfolio_feature_event_consultation": "Specific Event Style Consultation",
    "portfolio_feature_3_outfit_proposals": "3 Curated Outfit Proposals",
    "portfolio_feature_accessorizing_guide": "Advanced Accessorizing Guide",
    "portfolio_feature_event_virtual_try_on": "Event-Specific Virtual Try-On",
    "portfolio_feature_pose_variation_check": "Multiple Pose & Lighting Check",
    "portfolio_feature_shopping_consultation": "Pre-Shopping Strategy Session",
    "portfolio_feature_curated_shopping_list": "AI-Refined Global Shopping List",
    "portfolio_feature_style_integration_session": "New Item Integration Session",
    "portfolio_feature_ai_product_search": "Advanced AI Visual Product Search",
    "portfolio_feature_vto_shortlist": "Virtual Try-On for Selected Items",
    "portfolio_feature_makeup_video_call": "Makeup & Grooming Video Call",
    "portfolio_feature_product_recommendations": "Personalized Product Recommendations",
    "portfolio_feature_technique_guide": "Step-by-Step Technique Guide",
    "portfolio_feature_ai_face_analysis": "AI Face Shape & Feature Analysis",
    "portfolio_feature_virtual_makeup_try_on": "Virtual Makeup Try-On Experience",
    "portfolio_feature_color_consultation": "Professional Color Consultation",
    "portfolio_feature_outfit_color_guide": "Outfit Color Coordination Guide",
    "portfolio_feature_ai_color_detection": "AI Skin & Undertone Detection",
    "portfolio_feature_interactive_palette": "Interactive Seasonal Palette",
    "portfolio_feature_color_analysis": "Comprehensive Color Analysis",
    "portfolio_feature_wardrobe_edit": "Guided Wardrobe Edit",
    "portfolio_feature_style_guide": "Personalized Digital Style Guide",
    "portfolio_feature_all_essential_features": "Includes all Essential Features",
    "portfolio_feature_personal_shopping": "Expert Personal Shopping Assistant",
    "portfolio_feature_makeup_lesson": "1-on-1 Professional Makeup Lesson",
    "portfolio_feature_follow_up": "30-Day Style Follow-Up Session",
    "portfolio_feature_all_complete_features": "Includes all Complete Features",
    "portfolio_feature_photoshoot": "Professional High-End Photoshoot",
    "portfolio_feature_hair_consultation": "Expert Hair Styling Consultation",
    "portfolio_feature_vip_concierge": "24/7 VIP Style Concierge Access",

    "portfolio.title": "Portfolio",
    "portfolio.description": "A selection of our finest work.",
    "portfolio.searchPlaceholder": "Search portfolio...",
    "portfolio.noResults.title": "No projects found",
    "portfolio.noResults.message": "Try adjusting your search terms.",
    "portfolio_category_editorial": "Editorial",
    "portfolio_category_street": "Street Style",
    "portfolio_category_commercial": "Commercial",
    "portfolio_category_portraits": "Portraits",
    "portfolio_category_personal": "Personal Styling",
    "portfolio_category_wardrobe": "Wardrobe",
    "portfolio_category_events": "Events",
    "portfolio_category_specialty": "Specialty",
    "portfolio.item1.title": "Urban Vogue",
    "portfolio.item1.desc": "City chic editorial",
    "portfolio.item2.title": "Street Beat",
    "portfolio.item2.desc": "Contemporary street fashion",
    "portfolio.item3.title": "Summer Haze",
    "portfolio.item3.desc": "Commercial campaign",
    "portfolio.item4.title": "Modern Muse",
    "portfolio.item4.desc": "High fashion editorial",
    "portfolio.item5.title": "Raw Essence",
    "portfolio.item5.desc": "Classic portraits focusing on personality and elegance.",
    "portfolio.alpha.title": "Gen Alpha Digital",
    "portfolio.alpha.desc": "Exploring the digital-first aesthetic of the youngest generation.",
    "portfolio.z.title": "Gen Z Underground",
    "portfolio.z.desc": "Raw, authentic street styles influenced by underground culture.",
    "portfolio.millennial.title": "Millennial Minimal",
    "portfolio.millennial.desc": "Clean, sophisticated minimalism for the modern millennial.",
    "campaign.zara.title": "ZARA: Runway Reimagined 2026",
    "campaign.zara.desc": "A commercial deep-dive into ZARA's SS26 collection, blending sculpted silhouettes with urban utilitarianism.",
    "campaign.hm.title": "H&M: Year of the Horse x Jacques Wei",
    "campaign.hm.desc": "Editorial fusion of Eastern heritage and modern street style, capturing the spirit of 2026.",
    "campaign.mango.title": "Mango: Sunset Dream AI Vision",
    "campaign.mango.desc": "An innovative, AI-generated campaign for Mango Teen, exploring the boundaries of digital aesthetics.",
    "campaign.zalando.title": "Zalando: Visionary Award 2026",
    "campaign.zalando.desc": "Showcasing the future of fashion through the lens of Zalando's top emerging designers.",
    "campaign.pkz.title": "PKZ: Zurich Fashion Week Elegance",
    "campaign.pkz.desc": "Premium styling and high-end elegance from Switzerland's leading fashion retailer.",
    "campaign_soft_power_title": "Soft Power Revolution",
    "campaign_soft_power_desc": "Embrace the 2026 executive aesthetic: rounded shoulders, pastel power suits, and fluid tailoring.",
    "campaign_sportif_chic_title": "Sportif Chic & Wellness",
    "campaign_sportif_chic_desc": "Elevated athletic wear meets everyday luxury. Technical fabrics with feminine touches.",
    "trend_alpha_cyber_soft_title": "Digital Pastel Fusion",
    "trend_z_poet_core_title": "Romantic Academic",
    "trend_millennial_glamoratti_title": "80s Opulence Redux",
    "trend_classic_guardian_title": "Protective Elegance",
    "campaign_badge_trending": "Trending",

    "portfolioPage_service_personalStyling_title": "Personal Styling",
    "portfolioPage_service_personalStyling_description": "Complete style overhaul.",
    "portfolioPage_service_wardrobeCuration_title": "Wardrobe Curation",
    "portfolioPage_service_wardrobeCuration_description": "Optimize your closet.",
    "portfolioPage_service_eventStyling_title": "Event Styling",
    "portfolioPage_service_eventStyling_description": "Perfect look for any occasion.",
    "portfolioPage_service_individualShopping_title": "Personal Shopping",
    "portfolioPage_service_individualShopping_description": "Curated shopping experience.",
    "portfolioPage_service_makeupAdvisory_title": "Makeup Advisory",
    "portfolioPage_service_makeupAdvisory_description": "Beauty to match your style.",
    "portfolioPage_service_colorAnalysis_title": "Color Analysis",
    "portfolioPage_service_colorAnalysis_description": "Find your perfect palette.",
    "portfolioPage_service_premiumInPerson_title": "Premium In-Person",
    "portfolioPage_service_businessWorkshops_title": "Business Styling & Workshops",
    "portfolioPage_service_businessWorkshops_description": "Elevate your company's professional image.",
    "portfolioPage_service_styleTransformation_title": "Style Transformation",
    "portfolioPage_service_styleTransformation_description": "A complete reinvention of your personal style.",
    "portfolioPage_package_essential": "Essential",
    "portfolioPage_package_complete": "Complete",
    "portfolioPage_package_vip": "VIP",

    "campaign_included_services": "Included Services",

    "membership_cycle_weekly": "Weekly",
    "membership_cycle_monthly": "Monthly",
    "membership_cycle_quarterly": "Quarterly",
    "membership_subscribe_button": "Subscribe Now",
    "membership_cycle_free": "Free",
    "profilePage_membership_free": "Free",
    "profilePage_onDemand_title": "On-Demand Services",
    "profilePage_onDemand_description": "Book high-value features for a single use or limited duration.",
    "on_demand_status_expiry": "Expires:",
    "on_demand_status_remaining": "Remaining:",
    "on_demand_book_again": "Extend / Re-book",
    "on_demand_feature_wardrobe_3d_title": "24h 3D Access",
    "on_demand_feature_wardrobe_3d_desc": "Unlock full 360° views and fit analysis for all your outfits for 24 hours.",
    "on_demand_feature_runway_video_title": "Single Runway Video",
    "on_demand_feature_runway_video_desc": "Generate one cinematic AI runway video for any of your saved outfits.",
    "on_demand_feature_style_report_title": "Comprehensive Style Report",
    "on_demand_feature_style_report_desc": "Get a one-time multi-agent editorial analysis of your current look.",
    "on_demand_feature_color_analysis_title": "AI Color & Skin Analysis",
    "on_demand_feature_color_analysis_desc": "One-time deep AI analysis of your seasonal color, skin undertone, and hair/eye harmony.",
    "on_demand_feature_color_report_title": "Monthly Color Mastery Reports",
    "on_demand_feature_color_report_desc": "30 days of automated weekly reports on how to style your specific color season for upcoming trends.",
    "on_demand_feature_capsule_generator_title": "AI Capsule Wardrobe Generator",
    "on_demand_feature_capsule_generator_desc": "One-time AI generation of a specialized capsule wardrobe tailored to your season and occasion.",
    "on_demand_feature_magazine_lookbook_title": "Editorial Video Lookbook",
    "on_demand_feature_magazine_lookbook_desc": "Transform your favorite outfits into a cinematic editorial magazine video with narrative story.",
    "common_book": "Book",
    "common_active": "Active",
    "membership_discount_monthly": "Save 10%",
    "membership_discount_quarterly": "Save 20%",
    "membership_feature_free_1": "Standard Style Discovery",
    "membership_feature_free_2": "Curated Style Feed",
    "membership_feature_basic_1": "Standard Access",
    "membership_feature_basic_2": "Basic Wardrobe",
    "membership_feature_basic_3": "Limited Try-Ons",
    "membership_feature_basic_4": "Community Support",
    "membership_feature_premium_1": "Priority Access",
    "membership_feature_premium_2": "Unlimited Wardrobe",
    "membership_feature_premium_3": "Unlimited Try-Ons",
    "membership_feature_premium_4": "Email Support",
    "membership_feature_premium_5": "Exclusive Content",
    "membership_feature_premium_style_tips": "AI Style Tips",
    "membership_feature_advanced_1": "All Premium Features",
    "membership_feature_advanced_2": "1-on-1 Consultation",
    "membership_feature_advanced_3": "Early Access",
    "membership_feature_advanced_4": "VIP Support",
    "membership_feature_advanced_5": "Personal Shopper",
    "membership_feature_advanced_social_media": "Social Media Content Gen",
    "membership_feature_advanced_plan_integration": "Style Plan Integration",
    "membership_feature_advanced_automated_shopping": "Automated Shopping",
    "membership_feature_nextgen_1": "Eco-Style Insights",
    "membership_feature_nextgen_2": "Social Trend Alerts",
    "membership_feature_nextgen_3": "Curated Thrifting Guides",
    "membership_feature_nextgen_4": "TikTok Trend Integration",

    "pose_category_favorites": "Favorites",
    "pose_category_standard": "Standard",
    "pose_category_athletic": "Athletic",
    "pose_category_professional": "Professional",
    "pose_category_seasonal_professional": "Seasonal Pro",
    "pose_category_glamour": "Glamour",
    "pose_category_lifestyle": "Lifestyle",
    "pose_category_seasonal_advanced": "Seasonal Adv",
    "pose_category_countryside_activities": "Countryside",
    "pose_category_seasonal_countryside": "Seasonal Country",
    "pose_category_motorsport": "Motorsport",
    "pose_category_arena_sports": "Arena Sports",

    "pose_label_3_4_view": "3/4 View",
    "pose_label_front_view": "Front View",
    "pose_label_side": "Side Profile",
    "pose_label_back_view": "Back View",
    "pose_label_walking": "Walking Towards",
    "pose_label_walking_away": "Walking Away",
    "pose_label_athleisure": "Athleisure",
    "pose_label_athletic_jump": "Mid-Air Jump",
    "pose_label_yoga_stretch": "Yoga Stretch",
    "pose_label_sprinting_start": "Sprint Start",
    "pose_label_high_kick": "High Kick",
    "pose_label_basketball_shot": "Basketball Shot",
    "pose_label_leaning": "Leaning",
    "pose_label_power_stance": "Power Stance",
    "pose_label_power_stance_side": "Power Side",
    "pose_label_desk_pose": "Desk Seated",
    "pose_label_business_walk": "Business Walk",
    "pose_label_biz_casual": "Biz Casual",
    "pose_label_seated": "Seated",
    "pose_label_podium": "Podium",
    "pose_label_collaboration": "Collaboration",
    "pose_label_arms_crossed": "Arms Crossed",
    "pose_label_taking_notes": "Taking Notes",
    "pose_label_handshake": "Handshake",
    "pose_label_laptop_work": "Laptop Work",
    "pose_label_checking_watch": "Checking Watch",
    "pose_label_coffee_break": "Coffee Break",
    "pose_label_spring_awakening": "Spring Field",
    "pose_label_summer_breeze": "Summer Beach",
    "pose_label_winter_city_park": "Winter Park",
    "pose_label_ski_lift": "Ski Lift",
    "pose_label_winter_mountain_view": "Mountain View",
    "pose_label_snowman": "Snowman Fun",
    "pose_label_autumn_stroll": "Autumn Stroll",
    "pose_label_new_year": "New Year Toast",
    "pose_label_cityscape": "Cityscape",
    "pose_label_red_carpet": "Red Carpet",
    "pose_label_red_carpet_front": "Red Carpet Front",
    "pose_label_hollywood": "Hollywood Glam",
    "pose_label_grand_entrance": "Grand Entrance",
    "pose_label_formal": "Formal Gown",
    "pose_label_joyful_twirl": "Joyful Twirl",
    "pose_label_luxury_car": "Luxury Car",
    "pose_label_sunglasses_cool": "Cool Shades",
    "pose_label_balcony_evening": "Balcony Evening",
    "pose_label_chaise_lounge": "Chaise Lounge",
    "pose_label_mirror_makeup": "Mirror Makeup",
    "pose_label_high_fashion_hands": "High Fashion",
    "pose_label_stool_elegance": "Stool Elegance",
    "pose_label_windy_drama": "Windy Drama",
    "pose_label_city_stride": "City Stride",
    "pose_label_cafe_moment": "Cafe Moment",
    "pose_label_seated_casual": "Seated Casual",
    "pose_label_reading_nook": "Reading Nook",
    "pose_label_staircase_sit": "Staircase Sit",
    "pose_label_beach_run": "Beach Run",
    "pose_label_art_gallery": "Art Gallery",
    "pose_label_halloween": "Halloween",
    "pose_label_easter": "Easter",
    "pose_label_winter_forest_fun": "Winter Forest",
    "pose_label_apreski_chalet": "Apres Ski",
    "pose_label_christmas": "Christmas Tree",
    "pose_label_winter_wonderland": "Winter Wonderland",
    "pose_label_chalet_terrace": "Chalet Terrace",
    "pose_label_chalet_fireplace": "Fireplace",
    "pose_label_chalet_elegant_living": "Elegant Chalet",
    "pose_label_lying_lounge": "Sun Lounger",
    "pose_label_chalet_night_snow": "Night Snow",
    "pose_label_slope_party": "Slope Party",
    "pose_label_riding_mounted": "Horse Riding",
    "pose_label_riding_standing": "With Horse",
    "pose_label_hunting_ready": "Hunting Ready",
    "pose_label_hunting_walking": "Hunting Walk",
    "pose_label_country_fence": "Fence Lean",
    "pose_label_country_picnic": "Picnic",
    "pose_label_spring_equestrian": "Spring Ride",
    "pose_label_summer_polo": "Summer Polo",
    "pose_label_autumn_shooting": "Autumn Shoot",
    "pose_label_winter_riding": "Winter Ride",
    "pose_label_f1_standing": "F1 Standing",
    "pose_label_formula_e": "Formula E",
    "pose_label_nascar": "NASCAR",
    "pose_label_gtm": "GT Racing",
    "pose_label_rally": "Rally Win",
    "pose_label_basketball_dribble": "Dribbling",
    "pose_label_basketball_dunk": "Slam Dunk",
    "pose_label_hockey_slapshot": "Hockey Slapshot",
    "pose_label_hockey_celebration": "Hockey Goal",
    "pose_label_vintage_film_set": "Hollywood Set",
    "pose_label_award_stage": "Award Stage",
    "pose_label_modern_office": "Modern Office",
    "pose_label_downtown_crosswalk": "Downtown Crosswalk",
    "pose_label_hotel_bar": "Hotel Bar",
    "pose_label_rooftop_lounge": "Rooftop Lounge",
    "pose_label_art_gallery_minimal": "Minimalist Gallery",
    "pose_label_park_bench": "Park Bench",
    "pose_label_subway": "Subway Platform",
    "pose_label_museum_hallway": "Museum Hallway",
    "pose_label_boutique": "Fashion Boutique",
    "pose_label_boardroom": "Boardroom View",
    "pose_label_arch_staircase": "Arch. Staircase",
    "pose_label_greenhouse": "Greenhouse",
    "pose_label_classic_library": "Classic Library",
    "pose_label_urban_loft": "Urban Loft",
    "pose_label_marble_foyer": "Marble Foyer",
    "pose_label_pro_lounge_sit": "Lounge Meeting",
    "pose_label_pro_lounge_stand": "Lobby Stand",
    "pose_label_city_hall_tree": "City Hall Tree",
    "pose_label_city_hall_walk": "City Hall Walk",
    "pose_label_adv_lounge_sofa": "Velvet Lounge",
    "pose_label_adv_lounge_bar": "Hotel Bar",
    "pose_label_adv_city_hall_steps": "City Hall Steps",
    "pose_label_adv_city_hall_balcony": "Market View",

    "blogPage_title": "Fashion Journal",
    "blogPage_tagline": "Insights, trends, and style advice.",
    "editorial_rss_title": "Fashion Industry News",
    "editorial_rss_subtitle": "Curated updates from top global publications.",
    "blog_post_read_more": "Read More",
    "blog_byline": "By",
    "blog_post_1_title": "The Future of Sustainable Fashion",
    "blog_post_1_date": "October 26, 2025",
    "blog_post_1_excerpt": "Exploring how technology and ethics are reshaping the industry.",
    "blog_post_1_content": "<p>Content about sustainable fashion...</p>",
    "blog_post_2_title": "Top Trends for Spring 2024",
    "blog_post_2_date": "October 15, 2025",
    "blog_post_2_excerpt": "What to wear this coming season.",
    "blog_post_2_content": "<p>Content about spring trends...</p>",
    "blog_post_3_title": "Mastering the Capsule Wardrobe",
    "blog_post_3_date": "October 05, 2025",
    "blog_post_3_excerpt": "Do more with less.",
    "blog_post_3_content": "<p>Content about capsule wardrobes...</p>",
    "blog_post_4_title": "Digital Fashion: Beyond the Screen",
    "blog_post_4_date": "October 01, 2025",
    "blog_post_4_excerpt": "Virtual clothing is the new reality.",
    "blog_post_4_content": "<p>Content about digital fashion...</p>",
    "blog_post_5_title": "Accessories That Make the Outfit",
    "blog_post_5_date": "September 25, 2025",
    "blog_post_5_excerpt": "Small details, big impact.",
    "blog_post_5_content": "<p>Content about accessories...</p>",
    "blogPage_resources_title": "Professional Resources",
    "blogPage_resources_locked_msg": "Unlock our comprehensive style guides with Premium.",
    "blogPage_resources_upgrade": "Upgrade Now",
    "homePage_forCompanies": "For Companies",
    "homePage_forCompanies_link": "For Companies",

    "loading_rendering": "Rendering Fine Details...",
    "loading_generating_model": "Creating the new you...",
    "homePage_cta": "Try On Your Style",
    "homePage_bookConsultation": "Book a Consultation",
    "homePage_bookSession_link": "Book a Session",
    "homePage_uploadInput_label": "Upload your photo",

    // Double Carousel
    "carousel_section_label": "Discover",
    "carousel_section_title": "Your Journey to Effortless Style",
    "carousel_view_more": "View More",
    // Trends Page
    "trends_seo_title": "Fashion Trends & Style Inspiration | Constantina",
    "trends_seo_desc": "Discover the latest fashion trends, seasonal collections, and expert style advice curated by our AI styling team.",
    "trends_seo_keywords": "fashion trends, style inspiration, seasonal fashion, wardrobe essentials, style guide",
    "trends_page_subtitle": "2026 Style Vision",
    "trends_page_title": "Fashion Trends",
    "trends_page_description": "Explore the upcoming aesthetics and key movements defining the fashion landscape of 2026.",
    "trends_filter_all": "All Eras",
    "generation_alpha": "Gen Alpha",
    "generation_z": "Gen Z",
    "generation_millennial": "Millennial",
    "generation_classic": "Classic",
    "carousel_auto_edit": "Automobile & Fashion: The Bold Intersection",



    "guestAccess_title": "Guest Access Restricted",
    "guestAccess_message": "Please sign in to access this feature.",

    "myStylesPage_sourceOutfit": "Source Outfit",
    "myStylesPage_social_linkedin": "LinkedIn",
    "myStylesPage_social_twitter": "Twitter",
    "myStylesPage_social_instagram": "Instagram",
    "myStylesPage_title": "My Styles",
    "myStylesPage_tagline": "Your curated styles and inspirations.",
    "myStylesPage_outfitsTab": "Outfits",
    "myStylesPage_favoritesTab": "Favorites",
    "myStylesPage_lookbooksTab": "Lookbooks",
    "myStylesPage_adviceTab": "Saved Advice",
    "myStylesPage_analyticsTab": "Style Analytics",
    "myStylesPage_filterPlaceholder": "Filter items...",
    "myStylesPage_sortNewest": "Newest",
    "myStylesPage_sortOldest": "Oldest",
    "myStylesPage_sortNameAsc": "Name (A-Z)",
    "myStylesPage_sortNameDesc": "Name (Z-A)",
    "myStylesPage_compareMode_title": "Compare Mode",
    "myStylesPage_compareMode_select": "Select to Compare",
    "myStylesPage_compareMode_compareButton": "Compare ({{count}}/2)",
    "myStylesPage_exportBooklet": "Export Style Report",
    "myStylesPage_noPreview": "No Preview Available",
    "myStylesPage_favorite_remove_aria": "Remove from Favorites",
    "myStylesPage_favorite_add_aria": "Add to Favorites",
    "myStylesPage_loadOutfit": "Load Outfit",
    "myStylesPage_deleteOutfit": "Delete Outfit",
    "myStylesPage_createLookbook": "Create Lookbook",
    "myStylesPage_lookbookDescription": "{{count}} Outfits",
    "myStylesPage_noLookbooks": "No lookbooks created yet.",
    "myStylesPage_noAdvice": "No advice saved yet.",
    "myStylesPage_analyzeOutfit": "Analyze Outfit",
    "myStylesPage_savePlan": "Save Plan",
    "myStylesPage_adviceSaved": "Saved!",
    "myStylesPage_saveAdvice": "Save Advice",
    "myStylesPage_outfitDescriptionBase": "A stylish combination.",
    "myStylesPage_no_results": "No saved outfits found.",

    "styleAnalytics_noData": "Save outfits to see your style analytics.",
    "styleAnalytics_overallStats": "Wardrobe Statistics",
    "styleAnalytics_totalOutfits": "Total Outfits",
    "styleAnalytics_totalLookbooks": "Lookbooks Created",
    "styleAnalytics_favoriteOutfits": "Favorites",
    "styleAnalytics_colorPalette": "Color Palette Usage",
    "styleAnalytics_categoryDistribution": "Category Distribution",

    "color_group_black": "Blacks & Darks",
    "color_group_white": "Whites & Lights",
    "color_group_gray": "Grays",
    "color_group_brown": "Earth Tones",
    "color_group_red": "Reds",
    "color_group_orange": "Oranges",
    "color_group_yellow": "Yellows",
    "color_group_green": "Greens",
    "color_group_blue": "Blues",
    "color_group_purple": "Purples",
    "color_group_pink": "Pinks",
    "color_group_other": "Others",

    "wardrobe_title": "Wardrobe",
    "wardrobe_ai_studio_title": "AI Fashion Studio",
    "wardrobe_ai_studio_placeholder": "Describe a unique fashion item (e.g., 'A futuristic silver jacket')...",
    "wardrobe_ai_studio_generate": "Generate Item",
    "wardrobe_ai_studio_generating": "Designing...",
    "wardrobe_ai_studio_error": "Could not generate item. Please try a different description.",
    "wardrobe_category_Tops": "Tops",
    "wardrobe_category_Jackets": "Jackets & Outerwear",
    "wardrobe_category_Outerwear": "Outerwear",
    "wardrobe_category_Dresses": "Dresses",
    "wardrobe_category_Bottoms": "Bottoms",
    "wardrobe_category_Shoes": "Shoes",
    "wardrobe_category_Bags": "Bags",
    "wardrobe_category_Eyewear": "Eyewear",
    "wardrobe_category_Jewelry": "Jewelry",
    "wardrobe_category_Other": "Accessories & Other",
    "wardrobe_category_All": "All Categories",

    "lifeSphere_selection_title": "Your Current Focus",
    "lifeSphere_selection_desc": "Select your active Life Sphere to tailor recommendations.",
    "lifeSphere_executive_title": "Executive Ascendance",
    "lifeSphere_executive_desc": "Elevated professional presence and power dressing.",
    "lifeSphere_romantic_title": "Romantic Renaissance",
    "lifeSphere_romantic_desc": "Alluring, confident styling for your love life.",
    "lifeSphere_matriarch_title": "Effortless Matriarch",
    "lifeSphere_matriarch_desc": "Chic, functional elegance for family life.",
    "lifeSphere_creative_title": "Creative Flourishing",
    "lifeSphere_creative_desc": "Bold silhouettes reflecting artistic growth.",
    "wardrobe_tab_garments": "Garments",
    "wardrobe_tab_accessories": "Accessories",
    "wardrobe_tab_sets": "Curated Sets",
    "wardrobe_upload_garment_title": "Add New Garment",
    "wardrobe_upload_accessory_title": "Add New Accessory",
    "wardrobe_upload_garment": "Upload",
    "wardrobe_upload_accessory": "Upload",
    "wardrobe_searchPlaceholder": "Search wardrobe...",
    "wardrobe_sort_category": "Category",
    "wardrobe_sort_name": "Name",
    "wardrobe_sort_color": "Color",
    "wardrobe_sort_brand": "Brand",
    "wardrobe_allBrands": "All Brands",
    "wardrobe_all_categories": "All Categories",
    "wardrobe_no_results": "No items found.",
    "wardrobe_set_includes": "Includes {{count}} items",
    "wardrobeItemDetailsModal_category": "Category",
    "wardrobeItemDetailsModal_brand": "Brand",
    "wardrobeItemDetailsModal_material": "Material",
    "wardrobeItemDetailsModal_applyToOutfit": "Apply to Outfit",

    "wardrobe_item_white_tshirt": "Classic White Tee",
    "wardrobe_item_black_tshirt": "Essential Black Tee",
    "wardrobe_item_cream_sweater": "Cashmere Cream Sweater",
    "wardrobe_item_silk_blouse": "Silk Blouse",
    "wardrobe_item_denim_jacket": "Vintage Denim Jacket",
    "wardrobe_item_black_blazer": "Tailored Black Blazer",
    "wardrobe_item_leather_jacket": "Biker Leather Jacket",
    "wardrobe_item_trench_coat": "Classic Trench Coat",
    "wardrobe_item_puffer_jacket": "Navy Puffer Jacket",
    "wardrobe_item_wool_coat": "Camel Wool Coat",
    "wardrobe_item_black_dress": "Little Black Dress",
    "wardrobe_item_floral_sundress": "Floral Sundress",
    "wardrobe_item_blue_jeans": "Straight Leg Blue Jeans",
    "wardrobe_item_black_trousers": "Wool Trousers",
    "wardrobe_item_black_skirt": "Satin Midi Skirt",
    "wardrobe_item_beige_shorts": "Linen Shorts",
    "wardrobe_item_black_heels": "Classic Pumps",
    "wardrobe_item_white_sneakers": "Minimalist Sneakers",
    "wardrobe_item_brown_boots": "Leather Ankle Boots",
    "wardrobe_item_brown_tote": "Leather Tote Bag",
    "wardrobe_item_black_handbag": "Quilted Handbag",
    "wardrobe_item_brown_sunglasses": "Tortoiseshell Sunglasses",
    "wardrobe_item_pearl_necklace": "Pearl Necklace",
    "wardrobe_item_silver_watch": "Stainless Steel Watch",
    "wardrobe_item_pearl_earrings": "Pearl Earrings",
    "wardrobe_item_red_scarf": "Cashmere Scarf",
    "wardrobe_item_fedora_hat": "Wool Fedora",
    "wardrobe_item_brown_belt": "Leather Belt",
    "accessory_set_everyday_essentials": "Everyday Essentials",
    "accessory_set_city_sleek": "City Sleek",

    "feature_locked_advanced": "Advanced Plan Feature",
    "feature_locked_premium_generic": "Premium Feature",
    "feature_locked_advanced_generic": "Advanced Feature",
    "feature_locked_guest": "Feature Locked (Guest)",
    "upgrade_membership": "Upgrade Membership",
    "view_plans": "View Plans",

    "common_close": "Close",
    "common_applied": "Applied",
    "common_na": "N/A",
    "common_next": "Next",
    "common_back": "Back",
    "common_copied": "Copied!",
    "common_error_invalid_email": "Please enter a valid email.",
    "payment_modal_select_method": "Select Payment Method",
    "payment_method_card": "Credit Card",
    "payment_method_paypal": "PayPal",
    "payment_method_klarna": "Klarna",
    "payment_method_twint": "Twint",
    "payment_method_sofort": "Sofort",
    "payment_email_label": "Confirm Email Address",
    "payment_mobile_label": "Mobile Number",
    "payment_cardholder_name": "Cardholder Name",
    "payment_card_number": "Card Number",
    "payment_expiry": "Expiry",
    "payment_cvc": "CVC",
    "payment_error_email_required": "Email address is required.",
    "payment_error_phone_required": "Mobile number is required.",
    "payment_error_invalid_email": "Please enter a valid email address.",
    "payment_error_invalid_phone": "Please enter a valid mobile number.",
    "payment_error_invalid_card": "Invalid card number.",
    "payment_error_invalid_expiry": "Invalid or expired date.",
    "payment_error_invalid_cvc": "Invalid CVV.",
    "payment_success_title": "Payment Successful!",
    "payment_success_message": "Your membership has been upgraded successfully.",
    "payment_failed_title": "Payment Failed",
    "payment_failed_message": "We could not process your payment. Please try again.",
    "payment_continue_to": "Continue to payment with {{method}}",

    "outfitStack_title": "Outfit Stack",
    "outfitStack_undo": "Undo",
    "outfitStack_redo": "Redo",
    "outfitStack_empty_prompt": "Select items from your wardrobe to start styling.",
    "outfitStack_changeColor_aria": "Change color for {{itemName}}",
    "outfitStack_adjust_aria": "Adjust fit/placement for {{itemName}}",
    "outfitStack_remove_aria": "Remove {{itemName}}",
    "outfitStack_findSimilar_aria": "Find similar items to {{itemName}}",
    "outfitStack_findSimilar_main": "Shop Similar Items",
    "outfitStack_addToLookbook": "Add to Lookbook",
    "outfitStack_suggestVariations": "Suggest Variations",
    "outfitStack_analyzeColor": "Analyze Palette",
    "outfitStack_creativeTools": "Creative Tools",
    "outfitStack_saveOutfitFirstForLookbook": "Save outfit first to add to lookbook",
    "alert_selectGarmentFirst": "Please select a main garment first.",

    "canvas_uploadToStart": "Upload a photo to start styling",
    "canvas_generating_3d": "Generating 3D Views...",
    "canvas_shopTheLook": "Shop the Look",
    "canvas_favorite_add": "Add to Favorites",
    "canvas_favorite_remove": "Remove from Favorites",
    "canvas_view3D": "3D View",
    "canvas_colorPicker_recentlyUsed": "Recently Used",
    "canvas_colorPicker_selectRecent": "Select recent color",
    "canvas_colorPicker_predefinedColors": "Standard Colors",
    "canvas_colorPicker_select": "Select",
    "canvas_colorPicker_color": "color",
    "canvas_colorPicker_customColorPicker": "Custom color picker",
    "canvas_colorPicker_hue": "Hue",
    "canvas_colorPicker_saturation": "Saturation",
    "canvas_colorPicker_lightness": "Lightness",
    "canvas_colorPicker_applyColor": "Apply Color",
    "canvas_generation_failed": "Image generation failed. Please try again.",

    "sceneControl_title": "Scene Settings",
    "sceneControl_bg_studio": "Studio",
    "sceneControl_bg_street": "Street",
    "sceneControl_bg_nature": "Nature",
    "sceneControl_bg_cafe": "Cafe",
    "sceneControl_bg_beach": "Beach",
    "sceneControl_custom_bg_placeholder": "Describe a custom background...",

    "error_quota_exceeded": "Generation quota exceeded for your {{limit}} limit.",
    "error_generic_short": "An error occurred.",
    "error_title": "Error",
    "error_safety_block": "Content blocked for safety reasons ({{reason}}).",
    "error_apiKey_invalid": "Invalid API Key. Please check configuration.",
    "error_apiKey_permission": "API Key permission denied.",
    "error_rateLimit": "Service is busy. Please try again later.",
    "error_outfitCorrupted": "This saved outfit is corrupted or missing data.",
    "error_storage_full_outfit": "Storage full. Delete old outfits to save new ones.",
    "error_storage_full_lookbook": "Storage full. Delete old lookbooks.",
    "error_storage_full_profile": "Storage full. Could not save profile.",
    "error_storage_full_favorites": "Storage full. Could not update favorites.",
    "error_storage_full_content": "Storage full. Could not save content.",
    "error_network": "Network error. Please check your connection.",
    "error_unsupported_mime": "Unsupported image type: {{mimeType}}",
    "error_unsupported_format": "Unsupported file format.",
    "error_generic": "An error occurred in {{context}}.",
    "error_userExists": "User {{name}} already exists.",

    "startScreen_solveStyleProblem": "Solve a Style Problem",
    "homePage_solveStyleProblem_link": "Solve a Style Problem",
    "startScreen_imageTransformTitle": "Transform Your Style",
    "startScreen_imageTransformDescription": "Upload your photo to generate your AI fashion twin.",
    "startScreen_generatingModel": "Creating your digital model...",
    "startScreen_detectingAttributes": "Analyzing features...",
    "startScreen_loading_both": "Initializing AI Stylist...",
    "startScreen_generationFailed": "Model generation failed.",
    "startScreen_tryAgain": "Try Again",
    "startScreen_uploadErrorFileTypeError": "Please upload a valid image file.",
    "modelGeneration_cancel": "Cancel",

    "shareOutfitModal_title": "Share Your Look",
    "shareOutfitModal_download": "Download Image",
    "shareOutfitModal_shareAppLink": "Share App",
    "shareOutfitModal_descriptionPlaceholder": "Add a description...",
    "shareOutfitModal_aiContent_title": "AI Content Generator",
    "shareOutfitModal_aiContent_desc": "Generate captions for social media.",
    "shareOutfitModal_generating": "Writing captions...",
    "shareOutfitModal_generateButton": "Generate Social Content",
    "shareOutfitModal_contentSaved": "Saved",
    "shareOutfitModal_saveContent": "Save to Profile",
    "shareOutfitModal_saveContentTitle": "Social Post: {{itemName}}",
    "shareOutfitModal_download_filename": "constantina-outfit",
    "shareOutfitModal_shareText": "Check out my style on Constantina!",
    "shareOutfitModal_error_noImage": "No image available to share.",
    "shareOutfitModal_error_generationFailed": "Failed to generate content.",
    "social_with": "with",

    "lookbookCreatorModal_title": "Create Lookbook",
    "lookbookCreatorModal_close": "Close",
    "lookbookCreatorModal_tabCollage": "Collage",
    "lookbookCreatorModal_tabVideo": "Video",
    "lookbookCreatorModal_instructionsCollage": "Select multiple outfits to create a collage.",
    "lookbookCreatorModal_instructionsVideo": "Select one outfit to generate a shopping video.",
    "lookbookCreatorModal_generatedImageAlt": "Generated Lookbook",
    "lookbookCreatorModal_shopTheLook": "Shop the Look",
    "lookbookCreatorModal_generating": "Generating...",
    "lookbookCreatorModal_generateButton": "Create",
    "lookbookCreatorModal_saveButton": "Save Lookbook",
    "lookbookCreatorModal_saved": "Saved",
    "lookbookCreatorModal_namePlaceholder": "Lookbook Name",
    "lookbookCreatorModal_defaultFileName": "lookbook",
    "lookbookCreatorModal_errorSelectOutfits": "Please select at least one outfit.",
    "lookbookCreatorModal_errorNoPreviewImages": "Selected outfits are missing preview images.",
    "lookbookCreatorModal_errorGenerate": "Generation failed.",
    "lookbookGenError_safety": "Generation blocked by safety filters: {{details}}",
    "lookbookCreatorModal_error_noVideoLink": "Video generation completed but no link was returned.",
    "lookbookCreatorModal_step_generatingVideo": "Rendering video...",
    "lookbookCreatorModal_step_findingItems": "Finding similar items...",
    "lookbookCreatorModal_step_starting": "Initializing...",
    "lookbookCreatorModal_error_videoGeneration": "Video generation failed.",
    "lookbookCreatorModal_error_apiKey": "Please check your API key selection.",
    "lookbookCreatorModal_error_selectOneOutfit": "Please select exactly one outfit for video generation.",
    "lookbookCreatorModal_error_noPreviewForVideo": "Outfit has no preview image.",
    "lookbookCreatorModal_error_videoStart": "Failed to start video generation.",
    "lookbookCreatorModal_videoPrompt": "Cinematic fashion video of {{outfitName}}, photorealistic, 4k, slow motion",
    "runway_video_prompt": "A fashion model walking on a runway wearing this outfit, professional lighting, cinematic catwalk",
    "lookbookCreatorModal_error_enterName": "Please enter a name for your lookbook.",
    "lookbookCreatorModal_aspectRatio": "Aspect Ratio",
    "lookbookCreatorModal_socialLayout": "Social Layout (Influencer style)",
    "lookbookCreatorModal_socialLayoutDesc": "Optimized for Instagram stories and TikTok.",
    "lookbookCreatorModal_socialCaption": "AI Social Caption",
    "lookbookCreatorModal_captionPlaceholder": "AI-generated caption will appear here...",
    "lookbook_action_download": "Download Lookbook",

    // Capsule Generator
    "capsuleGenerator_title": "AI Capsule Wardrobe Generator",
    "capsuleGenerator_subtitle": "Create a versatile, cohesive wardrobe tailored to your style and the occasion.",
    "capsuleGenerator_premium_required": "This advanced AI styling tool is available for our Premium and Advanced members.",
    "capsuleGenerator_select_season": "Select Season",
    "capsuleGenerator_select_occasion": "Select Occasion",
    "capsuleGenerator_generate_btn": "Generate Capsule",
    "capsuleGenerator_generating": "Designing your capsule...",
    "capsuleGenerator_season_spring": "Spring",
    "capsuleGenerator_season_summer": "Summer",
    "capsuleGenerator_season_autumn": "Autumn",
    "capsuleGenerator_season_winter": "Winter",
    "capsuleGenerator_occasion_work": "Professional Workwear",
    "capsuleGenerator_occasion_casual": "Weekend Casual",
    "capsuleGenerator_occasion_travel": "Travel & Vacation",
    "capsuleGenerator_occasion_formal": "Formal Events",
    "capsuleGenerator_result_palette": "Color Palette",
    "capsuleGenerator_result_items": "Key Pieces",
    "capsuleGenerator_result_combinations": "Outfit Combinations",
    "capsuleGenerator_seo_title": "AI Capsule Wardrobe Generator | Constantina Lifestyle",
    "capsuleGenerator_seo_desc": "Generate a personalized capsule wardrobe based on your color season, body type, and style persona using advanced AI.",
    "capsuleGenerator_seo_keywords": "capsule wardrobe, AI stylist, fashion planning, minimalist wardrobe, color season analysis",
    "capsuleGenerator_empty_state": "Select your preferences and click \"Generate\" to see your personal capsule.",
    "retailSearchModal_title": "Shop Similar Items",
    "retailSearchModal_titleForGarment": "Shop Similar: {{garmentName}}",
    "retailSearchModal_close": "Close",
    "retailSearchModal_refine_title": "Refine Search",
    "retailSearchModal_refine_color": "Color",
    "retailSearchModal_refine_pattern": "Pattern",
    "retailSearchModal_refine_material": "Material",
    "retailSearchModal_refine_color_placeholder": "e.g. Navy Blue",
    "retailSearchModal_refine_pattern_placeholder": "e.g. Striped",
    "retailSearchModal_refine_material_placeholder": "e.g. Silk",
    "retailSearchModal_refine_button": "Update Search",
    "retailSearchModal_loading": "Searching global retailers...",
    "retailSearchModal_noResults": "No similar items found.",
    "retailSearchModal_sources": "Sources",
    "retailSearchModal_noPreview": "No Preview",
    "retailSearchModal_saveSearch": "Save to My Searches",
    "retailSearchModal_searchSaved": "Search Saved",

    "productDetailsModal_title": "Product Details",
    "productDetailsModal_retailer": "Retailer",
    "productDetailsModal_price": "Price",
    "productDetailsModal_viewOnSite": "View on Retailer Site",

    "styleTipsModal_loading": "Consulting AI Stylist...",
    "styleTipsModal_getNewTips": "Regenerate",

    "variationsModal_title": "Outfit Variations",
    "variationsModal_close": "Close",
    "variationsModal_loading": "Designing variations...",
    "variationsModal_regenerate": "Generate New Ideas",

    "shoppingBasket_title": "Shopping Basket",
    "shoppingBasket_empty": "Your basket is empty.",
    "shoppingBasket_total": "Total Estimate",
    "shoppingBasket_checkout": "Proceed to Checkout",
    "navbar_shopping_basket_aria": "Shopping Basket",

    "outfitNameInputModal_title": "Save Outfit",
    "outfitNameInputModal_cancel": "Cancel",
    "outfitNameInputModal_saveOutfit": "Save",
    "outfitNameInputModal_placeholder": "Outfit Name",
    "outfitNameInputModal_descriptionLabel": "Description",
    "outfitNameInputModal_descriptionPlaceholder": "Add notes about this look...",
    "outfitNameInputModal_tagsLabel": "Tags",
    "outfitNameInputModal_tagsPlaceholder": "summer, work, casual...",
    "outfitNameInputModal_poseNoteLabel": "Pose Note",
    "outfitNameInputModal_poseNotePlaceholder": "Notes on this specific pose...",
    "outfitNameInputModal_previewAlt": "Outfit Preview",
    "outfitNameInputModal_saveAsNew": "Save as New Outfit",
    "savedOutfit_posePrefix": "Pose:",

    "outfitComparison_title": "Outfit Comparison",
    "outfitComparison_differences": "Key Differences",
    "outfitComparison_loading": "Analyzing outfits...",



    "bookingPage_title": "Book a Consultation",
    "bookingPage_tagline": "Schedule your personalized styling session.",
    "bookingPage_developerNote_title": "Developer Note",
    "bookingPage_developerNote_text": "This form simulates a booking flow integrated with Google Calendar and Meet.",
    "bookingForm_services_label": "Select Services",
    "bookingForm_date_label": "Select Date & Time",
    "bookingForm_name_label": "Name",
    "bookingForm_name_placeholder": "Your Name",
    "bookingForm_email_label": "Email",
    "bookingForm_email_placeholder": "your@email.com",
    "bookingForm_phone_label": "Phone (Optional)",
    "bookingForm_phone_placeholder": "+1 234 567 890",
    "bookingForm_notes_label": "Notes / Goals",
    "bookingForm_notes_placeholder": "Tell us about your style goals...",
    "bookingForm_submitButton": "Confirm Booking",
    "bookingForm_submitButton_loading": "Booking...",
    "bookingForm_error_title": "Booking Failed",
    "bookingForm_success_title": "Booking Confirmed!",
    "bookingForm_success_message": "Your session has been scheduled. Check your email for details.",
    "bookingForm_success_message_email": "Your booking request has been submitted. Please check your email for the calendar invitation.",
    "bookingForm_startMeet": "Open Google Meet",
    "bookingForm_success_cta": "Book Another",
    "bookingForm_error_service": "Please select at least one service.",
    "bookingForm_error_dateTime": "Please select a date and time.",
    "bookingForm_error_name": "Name is required.",
    "bookingForm_error_email": "Email is required.",
    "bookingForm_error_email_invalid": "Invalid email address.",
    "bookingForm_error_phone_invalid": "Invalid phone number.",
    "bookingForm_error_submit": "Submission failed. Please try again.",
    "bookingConfirmation_title": "Confirm Details",
    "bookingConfirmation_subtitle": "Please review your booking details.",
    "bookingConfirmation_services": "Services",
    "bookingConfirmation_dateTime": "Date & Time",
    "bookingConfirmation_yourDetails": "Your Details",
    "bookingConfirmation_notes": "Notes",
    "bookingConfirmation_editButton": "Edit",
    "bookingConfirmation_confirmButton": "Confirm Booking",
    "calendar_selectTime": "Select Time",
    "month_jan": "January", "month_feb": "February", "month_mar": "March", "month_apr": "April", "month_may": "May", "month_jun": "June",
    "month_jul": "July", "month_aug": "August", "month_sep": "September", "month_oct": "October", "month_nov": "November", "month_dec": "December",
    "day_sun": "Sun", "day_mon": "Mon", "day_tue": "Tue", "day_wed": "Wed", "day_thu": "Thu", "day_fri": "Fri", "day_sat": "Sat",

    "profilePage_title": "My Profile",
    "profilePage_admin_title": "Admin Dashboard",
    "profilePage_admin_createUser": "Create New User",
    "profilePage_admin_username_placeholder": "Username",
    "profilePage_admin_createButton": "Create",
    "profilePage_admin_suffix_note": "Suffix '-user' will be added automatically.",
    "profilePage_stylePersona_title": "Style Persona",
    "profilePage_stylePersona_description": "AI-generated analysis based on your saved outfits.",
    "profilePage_stylePersona_noOutfits": "Save some outfits to generate your persona.",
    "profilePage_stylePersona_error": "Could not generate persona.",
    "profilePage_stylePersona_analyzing": "Analyzing...",
    "profilePage_stylePersona_analyzing_dna": "Analyzing your style DNA...",
    "profilePage_stylePersona_analyzeButton": "Analyze My Style",
    "profilePage_measurements_title": "Measurements & Attributes",
    "profilePage_measurements_description": "Keep your details up to date for better fit recommendations.",
    "profilePage_personalDetails_title": "Personal Details",
    "profilePage_measurements_height": "Height",
    "profilePage_measurements_weight": "Weight",
    "profilePage_measurements_chest": "Chest",
    "profilePage_measurements_waist": "Waist",
    "profilePage_measurements_hips": "Hips",
    "profilePage_measurements_colorSeason_label": "Color Season",
    "profilePage_measurements_ai_auto_detect": "AI Auto-Detect",
    "profilePage_measurements_height_placeholder": "cm/ft",
    "profilePage_measurements_weight_placeholder": "kg/lbs",
    "profilePage_measurements_chest_placeholder": "cm/in",
    "profilePage_measurements_waist_placeholder": "cm/in",
    "profilePage_measurements_hips_placeholder": "cm/in",
    "profilePage_measurements_shoeSize": "Shoe Size",
    "profilePage_measurements_shoeSize_placeholder": "e.g. 42 / 9",
    "profilePage_attributes_detected_title": "Detected Attributes",
    "profilePage_attributes_bodySize": "Body Size",
    "profilePage_attributes_hairColor": "Hair Color",
    "profilePage_attributes_eyeColor": "Eye Color",
    "profilePage_attributes_faceShape": "Face Shape",
    "profilePage_attributes_notDetected": "Not detected",
    "profilePage_preferredRetailers_label": "Preferred Retailers",
    "profilePage_preferredRetailers_description": "Select brands you love for better recommendations.",
    "profilePage_membership_title": "Membership",
    "profilePage_membership_tagline": "Manage your subscription plan.",
    "profilePage_membership_level": "Current Plan",
    "profilePage_membership_expiry_date": "Expiry Date",
    "profilePage_membership_status_basic": "Basic",
    "profilePage_membership_status_active": "{{level}} - Active until {{date}}",
    "profilePage_membership_status_active_no_date": "{{level}} - Active",
    "profilePage_membership_status_expired": "{{level}} - Expired on {{date}}",
    "profilePage_membership_basic": "Basic",
    "profilePage_membership_premium": "Premium",
    "profilePage_membership_advanced": "Advanced",
    "profilePage_membership_nextgen": "NextGen Access",
    "profilePage_membership_current": "Current Plan",
    "profilePage_membership_change_hint": "Changeable via upgrade payment only",
    "profilePage_membership_upgrade": "Upgrade",
    "profilePage_membership_label": "Membership",
    "profilePage_membership_month": "mo",
    "profilePage_membership_current_label": "Current Plan",
    "profilePage_membership_upgrade_button": "Upgrade",
    "profilePage_settings_title": "Settings",
    "profilePage_settings_quality_label": "Image Generation Quality",
    "profilePage_settings_quality_desc": "Higher quality may take longer to generate.",
    "profilePage_settings_quality_low": "Low (Faster)",
    "profilePage_settings_quality_medium": "Medium (Balanced)",
    "profilePage_settings_quality_high": "High (Best Results)",
    "profilePage_cloudSync_title": "Cloud Sync",
    "profilePage_cloudSync_description": "Backup or restore your data.",
    "profilePage_dataManagement_save": "Save to Cloud",
    "profilePage_dataManagement_load": "Load from Cloud",
    "profilePage_help_support_title": "Help & Support",
    "profilePage_restart_onboarding_desc": "View the tutorial again.",
    "profilePage_restart_onboarding_button": "Restart Onboarding",


    "agentWorkflow_title": "Styling Agent",
    "agentWorkflow_greeting": "Hello! I'm your dedicated Styling Agent. I can help you find items, book appointments, or create social media content for your looks. What's on your mind?",
    "agentWorkflow_error_noItemsFound": "I couldn't find any similar items right now.",
    "agentWorkflow_fallback": "I didn't quite catch that. Try asking to 'find similar items' or 'book a session'.",
    "agentWorkflow_error": "Sorry, I encountered an error.",
    "agentWorkflow_thinking": "Processing...",
    "agentWorkflow_placeholder": "Type a request...",
    "agentWorkflow_socialMediaSavedTitle": "Social Media Content",
    "shoppingAssistant_title": "Shopping Assistant",
    "shoppingAssistant_subtitle": "AI Powered",
    "shoppingAssistant_agent_prefix": "Findings from your {{agentName}} agent:",
    "shoppingAssistant_greeting": "Hi! I'm your AI Shopping Assistant. How can I help you today? You can ask me to find products, check your order status, or help with returns.",
    "shoppingAssistant_error_connection": "I'm sorry, I'm having trouble connecting right now.",
    "shoppingAssistant_history_cleared": "History cleared. How can I help you today?",
    "shoppingAssistant_clear_history": "Clear conversation",
    "shoppingAssistant_close": "Close assistant",
    "shoppingAssistant_role_assistant": "Assistant",
    "shoppingAssistant_copy_caption": "Copy caption",
    "shoppingAssistant_social_media_title": "AI Generated Social Captions",
    "shoppingAssistant_save_to_advice": "Save to Advice",
    "shoppingAssistant_select_slot": "Select",
    "shoppingAssistant_thinking": "Assistant is thinking...",
    "shoppingAssistant_input_placeholder": "Search products, track orders...",
    "shoppingAssistant_send_aria": "Send message",
    "shoppingAssistant_suggest_summer_dresses": "Summer dresses",
    "shoppingAssistant_suggest_track_order": "Track order",
    "shoppingAssistant_suggest_return_policy": "Return policy",
    "shoppingAssistant_response_products": "I found some {{category}} that you might like:",
    "shoppingAssistant_response_order_status": "Here is the status of your order {{orderId}}:",
    "shoppingAssistant_response_order_not_found": "I couldn't find that order. Please check the order ID and try again.",
    "shoppingAssistant_response_return_policy": "Our return policy allows you to return items within 30 days of delivery. Items must be unworn and in original packaging. Would you like to start a return for a specific order?",
    "shoppingAssistant_response_social_media": "I've drafted some custom social media captions based on your current look! Which one do you like best?",
    "shoppingAssistant_response_social_no_garment": "I'd love to help you with a post! Could you first select a garment in the dressing room so I have something to write about?",
    "shoppingAssistant_response_booking": "I can definitely help you book a professional styling session. When were you thinking?",
    "shoppingAssistant_service_styling_consultation": "Personal Styling Consultation",
    "shoppingAssistant_response_wardrobe_matches": "I found some matches in your wardrobe, plus a few pieces from our catalog to complete the look:",
    "shoppingAssistant_response_retail_matches": "Based on your style preferences, I found these items for you:",
    "shoppingAssistant_response_greeting": "Hello! I'm your personal style and shopping assistant. I can help you find products (in our shop or your wardrobe), create social media posts for your looks, or book a consultation. How can I help you today?",
    "shoppingAssistant_response_fallback": "I'm here to help with your style! You can ask me to find products, create social posts, or give you fashion advice.",
    "shoppingAssistant_order_status_label": "Order Status",
    "shoppingAssistant_order_id_label": "Order ID",
    "shoppingAssistant_order_date_label": "Date",
    "shoppingAssistant_order_items_label": "Items",
    "shoppingAssistant_order_total_label": "Total Amount",
    "shoppingAssistant_order_est_delivery_label": "Est. Delivery",
    "shoppingAssistant_order_track_cta": "Track Package",
    "shoppingAssistant_order_status_shipped": "Shipped",
    "shoppingAssistant_order_status_delivered": "Delivered",
    "shoppingAssistant_order_status_processing": "Processing",
    "shoppingAssistant_product_in_wardrobe": "In Your Wardrobe",
    "shoppingAssistant_product_low_stock": "Low Stock",
    "shoppingAssistant_product_price_wardrobe": "WARDROBE",
    "shoppingAssistant_product_add_to_basket": "Add to basket",
    "shoppingAssistant_product_owned": "Owned",
    "shoppingAssistant_product_already_in_wardrobe": "Already in your wardrobe",


    "styleAgent_quotaExceeded": "Style Agent limit reached for your membership level. Upgrade to create more agents.",
    "styleAgent_runAgent": "Run Agent",
    "styleAgent_running": "Running...",
    "styleAgent_lastEmail": "Last Email: {{date}}",
    "styleAgent_cacheActive": "Cached Results ({{intervals}} intervals left)",
    "styleAgent_emailSubject": "Your Style Agent Summary: {{agentName}}",
    "styleAgent_emailSent": "Email summary sent successfully.",

    "auth_error_emailExists": "This email is already registered. Please sign in instead.",

    "adminDashboard_title": "Admin Multi-Profile Management",
    "adminDashboard_subtitle": "Enable and manage system styling profiles",
    "adminDashboard_profile": "Profile",
    "adminDashboard_status": "Status",
    "adminDashboard_actions": "Actions",
    "adminDashboard_enable": "Enable Profile",
    "adminDashboard_disable": "Disable Profile",
    "adminDashboard_noProfiles": "No profiles found in the system.",
    "adminDashboard_tabUsers": "Users",
    "adminDashboard_tabAgents": "Agents",
    "adminDashboard_tabSettings": "Settings",
    "adminDashboard_tabCarousel": "Carousel & Hero",
    "adminDashboard_tabPortfolio": "Portfolio",
    "adminDashboard_heroTitle": "Homepage Hero Images (Compare Section)",
    "adminDashboard_heroFirst": "First Hero Image",
    "adminDashboard_heroSecond": "Second Hero Image",
    "adminDashboard_heroSave": "Save Hero Layout",
    "adminDashboard_carouselTitle": "Main Carousel Items",
    "carousel_fruling_elegance": "Spring Elegance",
    "carousel_fruling_casual": "Spring Casual",
    "carousel_fruling_elegant": "Spring Elegant",
    "adminDashboard_carouselAddItem": "Add Item",
    "adminDashboard_carouselEditItem": "Edit Carousel Item",
    "adminDashboard_carouselCreateItem": "Create Item",
    "adminDashboard_carouselSaveChanges": "Save Changes",
    "adminDashboard_portfolioTitle": "Portfolio Management",
    "adminDashboard_portfolioItem": "Portfolio Item",
    "adminDashboard_portfolioStatus": "Status",
    "adminDashboard_portfolioActive": "Active",
    "adminDashboard_portfolioInactive": "Inactive",
    "adminDashboard_portfolioPricing": "Pricing Tiers",
    "adminDashboard_portfolioBasePrice": "Base Price (EUR)",
    "adminDashboard_portfolioSaveSuccess": "Portfolio updated successfully",

    "trendSpotter.greeting": "Ready to stay ahead of the curve? I'm your Trend Spotter. Ask me about the latest runway hits, viral street styles, or what colors are dominating this season!",
    "trendSpotter.cleared": "Chat history cleared.",
    "trendSpotter.thinking": "Analyzing global trends...",
    "trendSpotter.placeholder": "Ask about emerging trends...",

    "testimonialsPage_title": "Client Stories",
    "testimonialsPage_tagline": "Hear from our global community of style enthusiasts.",
    "testimonialsPage_workInAction_title": "Work in Action",
    "testimonialsPage_workInAction_tagline": "Real results from our styling sessions and tools.",
    "testimonialsPage_workInAction_connectButton": "Connect Social Accounts",
    "testimonialsPage_workInAction_connecting": "Connecting...",
    "testimonialsPage_workInAction_youtubeTitle": "YouTube Makeovers",
    "testimonialsPage_workInAction_instagramTitle": "Instagram Reels",
    "testimonialsPage_workInAction_twitterTitle": "Style Tweets",
    "socialCarousel_simulation_note": "* Simulated social media feed",
    "portfolio_instagram_connect_title": "Connect on Instagram",
    "portfolio_instagram_connect_desc": "Follow our daily style stories, behind-the-scenes content, and community features.",
    "common_connect": "Connect",
    "portfolio_video_views": "{{views}} views",

    "threeSixty_dragToRotate": "Drag to Rotate",

    "styleReport_title": "Style Report",
    "styleReport_generatedFor": "Generated for {{username}}",
    "styleReport_date": "Date",
    "styleReport_profile_title": "Style Profile",
    "styleReport_no_persona": "No style persona generated yet.",
    "styleReport_outfits_title": "Saved Outfits",
    "styleReport_lookbooks_title": "Lookbooks",
    "styleReport_plans_title": "Style Plans",
    "styleReport_no_plans": "No style plans saved.",
    "styleReport_back": "Back to My Styles",
    "styleReport_print": "Print Report",

    "adjustment_fit_label": "Fit",
    "adjustment_fit_tight": "Tight",
    "adjustment_fit_regular": "Regular",
    "adjustment_fit_loose": "Loose",
    "adjustment_fit_oversized": "Oversized",
    "adjustment_scale_label": "Scale",
    "adjustment_rotation_label": "Rotation",
    "adjustment_x_offset_label": "Horizontal",
    "adjustment_y_offset_label": "Vertical",

    "footer_company": "Company",
    "footer_legal": "Legal",
    "footer_subscribe_title": "Stay in Style",
    "footer_subscribe_desc": "Join our newsletter for exclusive style tips and trends.",
    "footer_subscribe_placeholder": "Enter your email",
    "footer_subscribe_button_aria": "Subscribe",
    "footer_subscribe_success": "Thanks for subscribing!",
    "footer_subscribe_error": "Please enter a valid email.",
    "footer_copyright": "All rights reserved.",
    "footer_createdBy": "Created by",

    "testimonial_name_1": "Sophie M.",
    "testimonial_location_paris": "Paris, France",
    "testimonial_quote_1": "Constantina transformed my wardrobe. I finally know what colors make me shine!",
    "testimonial_name_2": "Alessandro R.",
    "testimonial_location_milan": "Milan, Italy",
    "testimonial_quote_2": "The in-person styling session was a game-changer for my professional image.",
    "testimonial_name_3": "Emma W.",
    "testimonial_location_london": "London, UK",
    "testimonial_quote_3": "Sorting my closet with the AI tools made decluttering actually fun and effective.",
    "testimonial_name_4": "Wei L.",
    "testimonial_location_shanghai": "Shanghai, China",
    "testimonial_quote_4": "Used the event styling service for a gala. The outfit recommendations were spot on.",
    "testimonial_name_5": "Kenji T.",
    "testimonial_location_tokyo": "Tokyo, Japan",
    "testimonial_quote_5": "The Style Persona feature accurately captured my aesthetic better than I could describe.",
    "testimonial_name_6": "Claire D.",
    "testimonial_location_montreal": "Montreal, Canada",
    "testimonial_quote_6": "Virtual try-on saved me so much time shopping online. Highly recommend!",
    "testimonial_name_7": "Elena G.",
    "testimonial_location_barcelona": "Barcelona, Spain",
    "testimonial_quote_7": "I love the weekly style plans. It takes the stress out of dressing for work.",
    "testimonial_name_8": "Omar K.",
    "testimonial_location_dubai": "Dubai, UAE",
    "testimonial_quote_8": "Finding similar items from photos is magic. Found a jacket I've been hunting for months.",

    "reel_1_caption": "Summer vibes with our new linen collection! ☀️",
    "reel_2_caption": "Get ready for the gala season. ✨",
    "reel_3_caption": "Street style inspiration from Tokyo. 🇯🇵",
    "trend_alpha_digital_twin_title": "Digital Twin Aesthetics",
    "trend_alpha_gaming_couture_title": "Gaming Couture",
    "trend_z_y2k_redux_title": "Y2K Redux",
    "trend_z_thrifting_elite_title": "Thrifting Elite",
    "trend_millennial_80s_glam_title": "80s Glam Revival",
    "trend_millennial_quiet_luxury_title": "Quiet Luxury Essentials",
    "trend_classic_heritage_title": "Heritage & Craft",
    "trend_tag_ai_native": "AI Native",
    "trend_tag_metaverse": "Metaverse",
    "trend_tag_nostalgia": "Nostalgia",
    "trend_tag_eco_conscious": "Eco-Conscious",
    "trend_tag_sophisticated": "Sophisticated",
    "trend_tag_timeless": "Timeless",
    "capsuleGenerator_lookbook_title": "Capsule Lookbooks",
    "capsuleGenerator_lookbook_subtitle": "Get inspired by curated capsule collections from our stylists.",
    "youtube_1_title": "10 Wardrobe Essentials You Need",
    "youtube_1_published": "2 days ago",
    "youtube_2_title": "How to Style Oversized Blazers",
    "youtube_2_published": "1 week ago",
    "tweet_1_author": "Fashion Weekly",
    "tweet_1_text": "The return of the 90s aesthetic is here to stay. What's your favorite throwback piece? 🧥",
    "tweet_1_timestamp": "2h ago",
    "tweet_2_author": "Style Scout",
    "tweet_2_text": "Just spotted the new Constantina collection. Absolute fire! 🔥 The AI styling tool is a game changer.",
    "tweet_2_timestamp": "5h ago",

    "nav_user_status_current": "Current",
    "nav_user_status_active": "Active",
    "nav_user_action_login": "Login",
    "nav_user_action_delete": "Delete User",
    "nav_admin_model_config": "Admin: Model Configuration",
    "nav_admin_model_image_label": "Image Generation Model",
    "nav_admin_model_image_desc": "Primary model used for high-fidelity outfit and model generation.",
    "nav_admin_model_flash_label": "Flash Analysis Model",
    "nav_admin_model_flash_desc": "Fast model used for quick analysis, chat summaries, and trend spotting.",
    "nav_admin_model_pro_label": "Advanced Reasoning (Pro)",
    "nav_admin_model_pro_desc": "Powerful model used for deeper insights and complex fashion analysis.",
    "nav_admin_model_thinking_label": "Deep Think Model",
    "nav_admin_model_thinking_desc": "Specialized reasoning model for style plans and nuanced comparisons.",
    "nav_admin_model_video_label": "Video Generation (Veo)",
    "nav_admin_model_video_desc": "The model responsible for cinematic 3D and fashion videos.",
    "nav_membership_recommended": "RECOMMENDED",
    "membership_most_popular": "Most Popular",
    "nav_app_download_prefix_ios": "Download on the",
    "nav_app_store_ios": "App Store",
    "nav_app_download_prefix_android": "GET IT ON",
    "nav_app_store_android": "Google Play",

    "home_hero_title": "Revolutionize Your Style with AI Virtual Try-On",
    "home_hero_title_new": "Your Wardrobe is the Visual Manifestation of Your Next Chapter.",
    "home_hero_subtitle": "Stop managing your clothes. Start architecting your identity. Experience the world’s first transformational styling advisor that aligns your style with your soul.",
    "home_hero_cta": "Generate AI Model",
    "home_value_1_title": "AI-Powered Precision",
    "home_value_1_desc": "Our advanced algorithms ensure garments drape naturally and realistically on your digital twin.",
    "home_value_2_title": "Hyper-Realistic Visualization",
    "home_value_2_desc": "Experience style in stunning detail with high-fidelity textures and professional studio lighting.",
    "home_value_3_title": "Instant Style Inspiration",
    "home_value_3_desc": "Mix and match thousands of combinations instantly to discover your perfect look.",
    "home_how_it_works_title": "The 3 Pillars",
    "home_how_it_works_step1_title": "1. Archetype Analysis",
    "home_how_it_works_step1_desc": "We identify your psychological style archetype (Myth or Muse).",
    "home_how_it_works_step2_title": "2. Modular Curation",
    "home_how_it_works_step2_desc": "We build a high-performance, 2026-ready \"Bio-Digital\" wardrobe.",
    "home_how_it_works_step3_title": "3. Presence Coaching",
    "home_how_it_works_step3_desc": "We provide the \"Attitude\" blueprints to ensure you own every room you enter.",
    "homePage_visionTitle": "Our Vision",
    "homePage_vision_ai_agents_title": "AI Style Agents",
    "homePage_vision_ai_agents_desc": "Continuous analysis of trends and personalized recommendations running 24/7.",
    "homePage_vision_quality_title": "Uncompromising Quality",
    "homePage_vision_quality_desc": "Experience professional digital rendering and premium fashion curation.",
    "homePage_vision_digitalTwin_title": "Your Digital Twin",
    "homePage_vision_digitalTwin_desc": "A hyper-realistic avatar that evolves alongside your personal success journey.",
    "home_seo_title": "Constantina | AI Virtual Try-On & Personal Stylist",
    "home_seo_desc": "Transform your shopping experience with our AI virtual fitting room. Discover your style identity with 2026 trends like Transformative Teal and Quiet Luxury.",
    "home_seo_keywords": "AI Virtual Try-On, Personal Stylist, Digital Wardrobe, Fashion Tech, Outfit Creator, Transformative Teal, Y2K Renaissance, Sustainable Fashion, Stealth Wealth, 2026 Fashion Trends",
    "home_empathy_title": "Is your style lagging behind your success?",
    "home_empathy_desc": "Most women evolve faster than their wardrobes. If you are stepping into a new level of leadership, love, or freedom, your \"Quiet Luxury\" from last year is no longer enough. You don't need an app to sort your clothes; you need an advisor to curate your future.",
    "home_press_title": "As Featured In",

    "profile_seo_title": "My Profile - Constantina",
    "profile_seo_desc": "Manage your style persona, membership, and account settings on Constantina.",
    "profile_seo_keywords": "user profile, style persona, account settings, Constantina",

    "canvas_seo_title": "Virtual Dressing Room - Constantina",
    "canvas_seo_desc": "Mix and match clothes on your digital twin. Visualize your style with our advanced AI outfit creator.",
    "canvas_seo_keywords": "outfit creator, virtual dressing room, fashion visualizer, 3D outfit view, AI styling, virtual try-on",

    // Payment & Membership
    "profilePage_register_to_unlock": "Register to Unlock",
    "profilePage_guest_cta_title": "Unlock Your Full Style Potential",
    "profilePage_guest_cta_desc": "Join Constantina today to save your outfits, generate your style persona, and get personalized recommendations from our AI stylists.",
    "voucher_title": "Gift Vouchers",
    "voucher_cta": "Buy Gift Voucher",
    "voucher_tagline": "Give the gift of style.",

    "aboutPage_certified_milano": "Mastering Fashion Styling - Milan",
    "aboutPage_certified_london": "Fashion Communication - London",

    // Campaigns
    "campaign_new_year_title": "New Year, New Style",
    "campaign_new_year_desc": "Start the year with a professional wardrobe refresh.",
    "campaign_executive_title": "Executive Presence",
    "campaign_executive_desc": "Elevate your professional brand with our premium business packages.",
    "campaign_color_title": "Palette Perfect",
    "campaign_color_desc": "Discover the colors that make you glow with our seasonal analysis.",
    "campaign_event_glamour_title": "Event Glamour",
    "campaign_event_glamour_desc": "Dazzle at your next big event with our expert styling.",
    "campaign_badge_limited_time": "Limited Time",
    "campaign_badge_professional": "Professional",
    "campaign_badge_bestseller": "Bestseller",
    "campaign_badge_events": "Events",
    "campaign_badge_seasonal": "Seasonal",
    "campaign_membership_boost_title": "Membership Boost",
    "campaign_membership_boost_desc": "Upgrade your membership today and unlock exclusive AI features at a special rate.",
    "campaign_shopping_title": "Smart Shopper",
    "campaign_shopping_desc": "Learn to shop with intention and build a wardrobe you love.",
    "campaign_style_transformation_title": "Style Transformation",
    "campaign_style_transformation_desc": "A comprehensive journey to discover your true style identity.",
    "campaign_summer_title": "Summer Radiant Style",
    "campaign_summer_desc": "Glow this summer with our curated warm-weather essentials.",
    "campaign_easter_title": "Easter Spring Renewal",
    "campaign_easter_desc": "Refresh your look for spring with our curated Easter specials.",

    // Carousel
    "carousel_winter_elegance": "Winter Elegance: The Art of Layering",
    "carousel_spring_elegance": "Spring Elegance: Texture & Movement",
    "carousel_minimalist_wardrobe": "The Minimalist Wardrobe Guide",
    "carousel_power_dressing": "Power Dressing: The Soft Revolution",
    "carousel_spring_trends": "Spring 2026 Trend Report",
    "carousel_sustainable_fashion": "Sustainable Fashion: Intentional Choices",
    "carousel_accessory_edit": "The Accessory Edit: From Afterthought to Architecture",
    "carousel_sport_edit": "Sport Chic: The New Athletic Aesthetic",
    "carousel_evening_glamour": "Evening Glamour: Nocturnal Aesthetics",
    "carousel_travel_essentials": "Travel Essentials: The Jet-Set Capsule",
    "carousel_instagram_reel": "Instagram Reel",
    "canvas_result_alt": "Virtual Try-On Result",
    "sceneControl_background_label": "Background",
    "sceneControl_modelScale_label": "Model Scale",
    "aboutPage_title": "Your Wardrobe is the Visual Manifestation of Your Next Chapter.",
    "aboutPage_tagline": "Stop managing your clothes. Start architecting your identity.",
    "aboutPage_paragraph1": "Is your style lagging behind your success?",
    "aboutPage_paragraph2": "Most women evolve faster than their wardrobes. If you are stepping into a new level of leadership, love, or freedom, your \"Quiet Luxury\" from last year is no longer enough. You don't need an app to sort your clothes; you need an advisor to curate your future.",
    "aboutPage_missionText": "Experience the world’s first transformational styling advisor that aligns your style with your soul.",
    "aboutPage_techTitle": "The Intelligence Behind the Art",
    "aboutPage_techText_p1": "We utilize the most advanced multimodal models and beyond—to perform real-time visual analysis of garments, textures, and silhouettes.",
    "aboutPage_techText_p2": "Every recommendation is grounded in professional styling principles, color theory, and historical fashion contexts, ensuring that our AI remains a tool for elevation, not just automation.",
    "aboutPage_teamTitle": "Our Visionaries",
    "aboutPage_socialTitle": "Connect with Our Future",
    "aboutPage_socialText": "Join our community of forward-thinking stylists and technophiles as we redefine what it means to be well-dressed.",
    "aboutPage_contactUs": "Book a Consultation",
    "author_elara_vance_name": "Constantina",
    "author_elara_vance_bio": "A veteran of Milan's fashion houses with a deep passion for the intersection of technology and heritage styling.",
    "elara-vance_role": "Creative Director",
    "author_julian_sinclair_name": "Hannes",
    "author_julian_sinclair_bio": "Specialized in AI ethics and visual processing patterns, ensuring our styling remain humane and intuitive.",
    "julian-sinclair_role": "Head of AI Architecture",
    "author_heidi_steiner_name": "Heidi Steiner",
    "author_heidi_steiner_bio": "Bringing years of high-end boutique concierge experience to the digital sphere.",
    "heidi-steiner_role": "Chief Concierge",
    "author_lukas_weber_name": "Lukas Weber",
    "author_lukas_weber_bio": "Focusing on sustainable fashion data and sourcing transparency in the digital age.",
    "lukas-weber_role": "Sustainability Lead",
    "contact_title": "Let's Connect",
    "contact_subtitle": "Have questions about our AI styling or want to book a custom workshop? Reach out and we'll get back to you within 24 hours.",
    "contact_info_title": "Contact Details",
    "contact_email_label": "Email",
    "contact_phone_label": "Phone",
    "contact_office_label": "Office",
    "contact_follow_us": "Follow Us",
    "contact_success_title": "Message Sent!",
    "contact_success_desc": "Thank you for reaching out. Konstantina will review your message and respond shortly.",
    "contact_form_name": "Name",
    "contact_form_email": "Email",
    "contact_form_subject": "Subject",
    "contact_form_message": "Message",
    "contact_form_submit": "Process Message",
    "contact_form_placeholder_name": "Your name",
    "contact_form_placeholder_email": "your@email.com",
    "contact_form_placeholder_subject": "What is this about?",
    "contact_form_placeholder_message": "Tell us how we can help...",
    "contact_form_send_another": "Send another message",
    "wardrobe_item_uploaded_name": "My Uploaded Photo",
    "brand_custom": "Custom",
    "material_custom": "Standard",
    "pressPage_title": "Press & Collaborations",
    "pressPage_tagline": "Leading the conversation in digital fashion innovation.",
    "pressPage_featured_title": "As Seen In",
    "pressPage_partners_title": "Brand Partners",
    "press_vogue_quote": "Redefines personal styling with AI precision.",
    "press_harpers_quote": "The future of the digital wardrobe is here.",
    "press_elle_quote": "A seamless blend of technology and high fashion.",
    "press_brand1_desc": "Exclusive digital showroom integration.",
    "press_brand2_desc": "Virtual try-on partnership.",
    "press_brand3_desc": "Curated capsule collection.",
    "legalPage_title": "Legal Information",
    "legalPage_tagline": "Terms, privacy, and important legal information about our services.",
    "seo_legal_title": "Legal Information - Terms & Privacy Policy",
    "seo_legal_description": "Read our terms of service, privacy policy, cookie policy and legal impressum.",
    "seo_legal_kw1": "terms of service",
    "seo_legal_kw2": "privacy policy",
    "seo_legal_kw3": "legal information",
    "seo_legal_kw4": "impressum",
    "legalPage_impressum_title": "Impressum (Legal Notice)",
    "legalPage_terms_title": "Terms and Conditions",
    "legalPage_privacy_title": "Privacy Policy",
    "legalPage_cookies_title": "Cookie Policy",
    "rss_source_vogue": "Vogue",
    "rss_source_elle": "Elle",
    "rss_source_harpers": "Harper's Bazaar",
    "rss_source_fashionista": "Fashionista",
    "rss_source_bof": "Business of Fashion",
    "rss_source_journelles": "Journelles",
    "rss_source_highsnobiety": "Highsnobiety",
    "rss_source_instyle": "InStyle",
    "rss_source_glamour": "Glamour",
    "rss_source_beige": "Beige",
    "rss_source_refinery29": "Refinery29",
    "rss_source_grazia": "Grazia",
    "rss_source_originalcopy": "The Original Copy",
    "rss_source_modepilot": "Modepilot",
    "rss_source_fashionunited": "FashionUnited",
    "rss_source_jolie": "Jolie",
    "rss_source_cosmopolitan": "Cosmopolitan",
    "rss_source_mashasedgwick": "Masha Sedgwick",
    "rss_source_ohhcouture": "Ohh Couture",
    "rss_source_carodaur": "Caro Daur",
    "rss_source_novalanalove": "Novalanalove",
    "rss_source_constantina": "Constantina",
    "booklet_minimalist_title": "The Minimalist Wardrobe Guide",
    "booklet_minimalist_desc": "Master the art of building a versatile, high-quality wardrobe with fewer pieces",
    "booklet_color_theory_title": "Color Theory Essentials",
    "booklet_color_theory_desc": "Discover your perfect color palette and learn to create harmonious outfits",
    "booklet_executive_title": "Executive Presence Styling",
    "booklet_executive_desc": "Professional styling guide for building authority through your wardrobe",
    "booklet_capsule_title": "The Capsule Wardrobe Blueprint",
    "booklet_capsule_desc": "Complete guide to creating seasonal capsule collections that work together",
    "booklet_downloading": "Downloading",
    "resource_category_style": "Style",
    "resource_category_color": "Color",
    "resource_category_business": "Business",
    "about_usp_title": "Why Constantina?",
    "about_usp_1_title": "Human-Centric AI",
    "about_usp_1_desc": "The efficiency of AI combined with the intuition of expert stylists.",
    "about_usp_2_title": "Data-Driven Trends",
    "about_usp_2_desc": "Real-time analysis of global trends from major fashion capitals.",
    "about_usp_3_title": "Personal Branding",
    "about_usp_3_desc": "We don't just dress you; we help you project your most authentic self.",
    "about_usp_4_title": "Global Reach",
    "about_usp_4_desc": "High-end styling accessible, no matter where you are in the world.",
    "about_certification_title": "Our Certifications",
    "about_certification_desc": "Expertise recognized by leading fashion institutions.",
    "wardrobe_item_elegant_blue": "Elegant Blue Gown",
    "wardrobe_item_elegant_black_stairs": "Elegant Black Evening Dress",
    "wardrobe_item_elegant_wool_coat": "Elegant Wool Coat",
    "wardrobe_item_elegant_gray_studio": "Gray Art Studio Ensemble",
    "wardrobe_item_elegant_autumn": "Autumn City Elegance",
    "accessory_set_elegant_collection": "Elegant Collection",

    "auth_coupon_placeholder": "Coupon Code (Optional)",
    "user_status_registered": "Registered",
    "user_status_validated": "Pending Approval",
    "user_status_active": "Active",
    "user_status_inactive": "Inactive",
    "user_status_deleted": "Deleted",
    "auth_pending_admin": "Account Pending Admin Approval",
    "auth_pending_confirmation": "Please confirm your email address.",
    "auth_account_deactivated": "This account has been deactivated."
  }
};
